import React from 'react';
import './OrderPlanning.css';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import {
  Popover,
  InputBase,
  Tooltip,
  Chip,
  DialogTitle,
  DialogActions,
  DialogContent,
  Dialog,
  DialogContentText, FormControlLabel, Typography,
} from '@mui/material';
import { TextField, IconButton, Button } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@material-ui/icons/Close';
import TopToolbar from '../global/subcomponents/topToolbar/TopToolbar';
import { BACK_BUTTON } from '../claims/constants';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RefreshIcon from '@material-ui/icons/Refresh';
import { dynamicColumnTypes, generateId } from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { FTL_SAVED_SUCCESSFUL_MESSAGE } from '../fullTruckload/constants';
import { NO_RUNNING_RATE_MESSAGE } from '../inventory/constants';


class OrderPlanningForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      planName: '',
      rows: [],
      dynamicColumns: [],
      columnTypeAnchorEl: null,
      latestProductRequirementColumn: null,
      productRequirementPopover: {
        anchorEl: null,
        columnId: null,
        location: '',
        daysToCover: '',
        daysOfCoverateBaseOn: '',
        selectedTransitShipment: [],
      },
      savedProductRequirements: {},
      pendingProductRequirementColumn: null,
      openPOPopover: {
        anchorEl: null,
        columnId: null,
        selectedPO: [],
      },
      showPOSelector: false,
      savedOpenPOSelections: {},
      savedSelectedBrands: [],
      selectedBrandsPopover : {
        anchorEl : null,
        stage    : 'menu',
        selected : []
      },
      editingColumnId: null,
      editingLabel: '',
      newPOPopover: {
        anchorEl: null,
        columnId: null,
        selectedSupplier: '',
        selectedLocation: '',
      },
      savedNewPOSelections: {},
      pendingOpenPOColumn: null,
      pendingNewPOColumn: null,
      status: '',
      message: '',
      feedbackBarOpen: false,
      orderPlanningId: null,
      showAppendPrompt: false,
      pendingAutoPlanColumnId: null,
      pendingTransferRequest: null,
      showAppendPromptPO: false,
      onPOAppendConfirm: null,
      showUnits: true,
      showSkids: true,
      sortDirection: "asc",
      showFTLInTransitSelector: false,
      savedFTLInTransitSelections: {},
      pendingFTLInTransitColumn: null,
      ftlInTransitPopover: {
        anchorEl: null,
        columnId: null,
        selectedTransitShipment: [],
      },
      showAppendPromptFTL: false,
      ftlAppendConfirm: null,
      currentInventoryPopover: {
        anchorEl: null,
        daysOfCoverage: 14,
      },
      savedCurrentInventorySelections: {},
      inventorySummaryForFTL:{},
      openConfirmDialog: false
    };
    this.draggedColId = null;

  }

  componentDidMount() {
    const { editOrder } = this.props;
    if (editOrder) {
      const savedSelectedBrands = editOrder.savedSelectedBrands || [];
      this.setState(prevState => ({
        dynamicColumns: Object.values(editOrder.dynamicColumns),
        rows: editOrder.orderPlanningItems,
        planName: editOrder.planName,
        savedOpenPOSelections: editOrder.savedOpenPOSelections,
        savedFTLInTransitSelections: editOrder.savedFTLInTransitSelections,
        savedProductRequirements: editOrder.savedProductRequirements,
        savedNewPOSelections: editOrder.savedNewPOSelections,
        savedCurrentInventorySelections: editOrder?.savedCurrentInventorySelections,
        orderPlanningId: editOrder.orderPlanningId,
        savedSelectedBrands,
        selectedBrandsPopover: {
          ...prevState.selectedBrandsPopover,
          selected: savedSelectedBrands
        },
        showUnits: editOrder.filters?.showUnits ?? true,
        showSkids: editOrder.filters?.showSkids ?? true,
        sortDirection: editOrder.filters?.sortDirection ?? 'asc',
      }),()=>{
           this.fetchLatestBoxAndProducts()
           this.fetchInventorySummaryForFTL()
      });
    }else{
        this.setState((prev) => ({
                                savedCurrentInventorySelections: {
                                  ...prev.savedCurrentInventorySelections,
                                  ['currentInventory']: Number(14),
                                },
                                currentInventoryPopover: {
                                  anchorEl: null,
                                  daysOfCoverage: 14,
                                },
                              })
        );
    }
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {

    if(this.props.inventorySummaryForFTL !== prevProps.inventorySummaryForFTL){
      this.setState({inventorySummaryForFTL: this.props.inventorySummaryForFTL })
    }
    if (
        this.state.inventorySummaryForFTL !== prevState.inventorySummaryForFTL &&
        prevState.inventorySummaryForFTL &&
        Object.keys(prevState.inventorySummaryForFTL).length > 0
    ) {
      const { inventorySummaryForFTL } = this.props;

          const changedColumns = Object.keys(inventorySummaryForFTL).filter(columnId => (
            inventorySummaryForFTL[columnId] !== prevState.inventorySummaryForFTL[columnId]
          ));

          for (const colId of changedColumns) {
            await new Promise(resolve => {
              this.autoPlanPartial(colId);
              setTimeout(resolve, 50);
            });
          }
     }



    if (this.props.allShippedFTL !== prevProps.allShippedFTL) {
        this.refreshSavedFTLTransitSelections()
     }

     if (this.props.openAndPartialPurchaseOrders !== prevProps.openAndPartialPurchaseOrders) {
        this.refreshSavedOpenPOSelections()
     }

      if (this.props.productInventory !== prevProps.productInventory) {
          this.refreshCurrentInventory()
      }

      if (this.props.boxesInventory !== prevProps.boxesInventory) {
          this.refreshCurrentInventory()
      }

  }

  fetchLatestBoxAndProducts = () =>{
        const data = {locationId: this.props.fromLocation.shipAddressId };
        this.props.listAllProductInventory(data)
        this.props.listAllBoxInventory(data)
  }

  toggleShortcodeSort = () => {
  this.setState((prevState) => {
    const newDirection = prevState.sortDirection === 'asc' ? 'desc' : 'asc';

    const sortedRows = [...prevState.rows].sort((a, b) => {
      const A = (a.shortcode || '').toLowerCase();
      const B = (b.shortcode || '').toLowerCase();

      return newDirection === 'asc'
        ? A.localeCompare(B)
        : B.localeCompare(A);
    });

    return {
      sortDirection: newDirection,
      rows: sortedRows,
    };
  });
};

  openFeedbackBar = (status,message) => {
    this.setState({feedbackBarOpen: true,status, message })
  }

  closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false, message: '', status:'' })
  }

  startEditingColumn = (col) => {
    this.setState({
      editingColumnId: col.id,
      editingLabel: col.label,
    });
  };

  handleEditingLabelChange = (e) => {
    this.setState({ editingLabel: e.target.value });
  };

  isSaveNewPurchaseOrder = (col) =>{
    const savedSelection = this.state.savedNewPOSelections?.[col.id] || {};
    const selectedSupplierName = savedSelection.selectedSupplier;

    const selectedSupplierInfo = this.props.suppliers.find(
      supplier => supplier.name === selectedSupplierName
    );

    const supplierProducts = selectedSupplierInfo?.supplierProducts || [];
    const supplierShortcodes = supplierProducts.map(p => p.shortcode);

    const filteredRows = this.state.rows.filter(row => {
      const dynamicData = row.dynamic?.[col.id];
      return dynamicData && dynamicData.unit && dynamicData.skids;
    });

    const matchedRow = filteredRows.find(
      row => supplierShortcodes.includes(row.shortcode)
    );

    if(matchedRow){
      return true
    }else{
      return false
    }

  }

  saveColumnLabel = (col) => {
    const { editingLabel } = this.state;


    if(!col.isRenamed){
      this.updateHeaderLabel(col.id, editingLabel.trim() || col.label);
      }

    this.setState(prevState => {
      const updatedColumns = prevState.dynamicColumns.map(c =>
        c.id === col.id
          ? { ...c, label: editingLabel, isRenamed: true }
          : c
      );

      return {
        dynamicColumns: updatedColumns,
        editingColumnId: null,
        editingLabel: ''
      };
    });
  };

  refreshAllNewPurchaseOrders = () => {
    const { savedNewPOSelections, rows } = this.state;

    const refreshPromises = Object.entries(savedNewPOSelections).map(([colId, selection]) => {
      const existingPoNum = selection.poNum;

      if (!existingPoNum) {

        return Promise.resolve(null);
      }

      return new Promise((resolve) => {
        this.props.refreshNewPurchaseOrder({ poNumber: existingPoNum }, (response, result) => {
          if (response && result?.data?.purchaseOrder) {
            resolve({ colId, po: result.data.purchaseOrder });
          } else {
            resolve(null);
          }
        });
      });
    });

    Promise.all(refreshPromises).then((results) => {
      let updatedRows = [...rows];

      results.forEach((result) => {
        if (!result || !result.po) return;

        const { colId, po } = result;

        updatedRows = updatedRows.map((row) => {
          const matchingItem = po.orderItems.find(
            (item) => item.shortcode === row.shortcode
          );

          const updatedDynamic = {
            ...(row.dynamic || {}),
            [colId]: {
              ...row.dynamic?.[colId],
              unit: matchingItem ? matchingItem.quantityOrdered :null,
              skids: matchingItem ? matchingItem.skidsOrdered : null
            }
          };

          return {
            ...row,
            dynamic: updatedDynamic
          };
        });
      });

      this.setState({ rows: updatedRows });
    });
  };

  createFTLDraft = (col) => {
    const date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0)
    const { fromLocation} = this.props
    const savedSelection = this.state.savedProductRequirements?.[col.id] || {};
    const selectedLocationName = savedSelection.location;
    const toLocation = this.props.availableLocations.find((location) => location.name === selectedLocationName)

    let fltDraftId = savedSelection.fltDraftId;
    if (fltDraftId && savedSelection.selectedTransitShipment?.some(s => s.fullTruckloadId === fltDraftId)) {
        fltDraftId = null;
    }

    const toAddress = {
        selectedLocation: toLocation.name || '',
        contactName: toLocation.contactName || '',
        companyName: toLocation.companyName || '',
        phoneNumber: toLocation.phone || '',
        addressLine1: toLocation.addressLine1 || '',
        addressLine2: toLocation.addressLine2 || '',
        city: toLocation.city || '',
        stateOrProvince: toLocation.state || '',
        postalCode: toLocation.postalCode || '',
        country: toLocation.country || '',
        email: toLocation.email || '',
        shipAddressId: toLocation.shipAddressId || ''
    };

     const fromAddress = {
        selectedLocation: fromLocation.name || '',
        contactName: fromLocation.contactName || '',
        companyName: fromLocation.companyName || '',
        phoneNumber: fromLocation.phone || '',
        addressLine1: fromLocation.addressLine1 || '',
        addressLine2: fromLocation.addressLine2 || '',
        city: fromLocation.city || '',
        stateOrProvince: fromLocation.state || '',
        postalCode: fromLocation.postalCode || '',
        country: fromLocation.country || '',
        email: fromLocation.email || '',
        shipAddressId: fromLocation.shipAddressId || ''
    };

      const filteredRows = this.state.rows.filter(row => {
      const dynamicData = row.dynamic?.[col.id];
      return dynamicData && dynamicData.unit && dynamicData.skids;
    });

    const suppliers = this.props.suppliers;
    const items = filteredRows.map(row => {

      const dynamicKey = Object.keys(row.dynamic)[0];
      const { unit, skids } = row.dynamic[dynamicKey];

      const supplier = suppliers.find(s =>
        s.supplierProducts?.some(p => p.shortcode === row.shortcode)
      );

      const item = {
        shortcode: row.shortcode,
        quantity: Number(unit),
        numOfSkids: skids,
        isSample: false
      };

      if (supplier) {
        item.supplier = {
          supplierName: supplier.name,
          supplierId: supplier.supplierId
        };
      }

      return item;
    });

    const ftlEntry = {
    ...(fltDraftId && { fullTruckloadId: fltDraftId }),
    "items": items,
    "toAddress": toAddress,
    "fromAddress": fromAddress,
    "shipmentNumber": "",
    "sealNumber": "",
    "poNumber": "",
    "deliveryNumber": "",
    "truckNumber": "",
    "trailerNumber": "",
    "shipDate": date,
    "expectedDate": date,
    "receivedDate": date,
    "pickupTimeIn": date,
    "pickupTimeOut": date,
    "receivedTimeIn": date,
    "receivedTimeOut": date,
    "brokerName": "",
    "portOfEntry": "",
    "packingCost": "",
    "packingCostCurrency": "",
    "freightCostCurrency": "",
    "devanCostCurrency": "",
    "insuranceCostCurrency": "",
    "otherCostsCurrency": "",
    "freightCost": "",
    "devanCost": "",
    "insuranceCost": "",
    "otherCosts": "",
    "partiesToTransaction": "",
    "shipmentTerms": "",
    "dutiesTaxesPayableBy": "",
    "dutiesTaxesPayableByExporter": "",
    "dutiesTaxesPayableByOther": "",
    "currencyOfSale": "",
    "emergencyPhoneNum": "",
    "papsNumber": "",
    "shippingCarrier": null,
    "shippingCarrierAddress": null,
    "notes": "",
    "attachments": [],
    "billOfLading": null,
    "finalDocument": null,
    "status": "Draft",
    "allowChangeOfStatus": true,
    "activeStep": 3,
    "settingsAttachments": [],
    "newAttachments": [],
    "deletedAttachments": [],
    "errorMessage": "",
    "feedbackBarOpen": false,
    "itemsNotEnabled": [],
    "shipmentFor": "Warehouse",
    "transferFrom": fromLocation.shipAddressId,
    "transferTo":  toLocation.shipAddressId,
    "daysToCover": savedSelection.daysToCover,
    "daysOfCoverateBaseOn": savedSelection.daysOfCoverateBaseOn,
    "includeOpenPO": false,
    "daysToIncludePO": "",
    "filteredPackages": this.props.filteredPackages,
    "filteredProducts": this.props.filteredProducts,
    "carrierName": "-"
    }

    const callback = (status, response) => {

      if (status) {
        this.openFeedbackBar(
          'success',
          FTL_SAVED_SUCCESSFUL_MESSAGE
        );

        const newFullTruckloadId = response.fullTruckloadId;

        this.setState(prevState => {
          const updatedSelections = {
            ...prevState.savedProductRequirements,
            [col.id]: {
              ...prevState.savedProductRequirements?.[col.id],
              fltDraftId: newFullTruckloadId
            }
          };

          return {
            savedProductRequirements: updatedSelections,
          };
        },()=>{
         this.handleSave();
        });

      } else {
        this.openFeedbackBar('error', response)
        if(response === "FTL entry not found"){
            this.setState(prevState => ({
                    savedProductRequirements: {
                        ...prevState.savedProductRequirements,
                        [col.id]: {
                            ...prevState.savedProductRequirements?.[col.id],
                            fltDraftId: null
                        }
                    }
            }));
        }

      }
    };

    const newSettings = {
    "attachments": [],
    "deletedAttachments": []
    }

     if (fltDraftId) {
        this.props.saveFTLDraft(ftlEntry, callback);
    } else {
        this.props.saveFullTruckload(ftlEntry, newSettings, null, callback);
    }

  };

  saveNewPurchaseOrder = (col) => {
    const savedSelection = this.state.savedNewPOSelections?.[col.id] || {};
    const selectedSupplierName = savedSelection.selectedSupplier;
    const selectedLocationName = savedSelection.selectedLocation;
    const existingPoNum = savedSelection.poNum;

    const selectedLocation = this.props.availableLocations.find((location) => location.name === selectedLocationName)

    const selectedSupplierInfo = this.props.suppliers.find(
      supplier => supplier.name === selectedSupplierName
    );

    if (!selectedSupplierInfo) {
      this.openFeedbackBar('error', 'Supplier not found');
      return;
    }

    const supplierProducts = selectedSupplierInfo.supplierProducts || [];
    const internalProductInfo = selectedSupplierInfo.internalProductInfo || [];
    const supplierShortcodes = supplierProducts.map(p => p.shortcode);


    const filteredRows = this.state.rows.filter(row => {
      const dynamicData = row.dynamic?.[col.id];
      return dynamicData && dynamicData.unit && dynamicData.skids;
    });


    const unmatchedRow = filteredRows.find(
      row => !supplierShortcodes.includes(row.shortcode)
    );

    if (unmatchedRow) {
      this.openFeedbackBar(
        'error',
        `${selectedSupplierName} does not have the matching shortcode: ${unmatchedRow.shortcode}`
      );
      return;
    }


    const entries = filteredRows.map(row => {
      const dynamicData = row.dynamic[col.id];
      const product = supplierProducts.find(p => p.shortcode === row.shortcode);
      const internal = internalProductInfo.find(
        info => info.manufacturerPartNum === product?.supplierPartNumber
      );

      return {
        shortcode: row.shortcode,
        partNum: product?.supplierPartNumber || '',
        description: internal?.textDescription || '',
        discount: '0.00',
        price: product?.price || '0.00',
        quantity: dynamicData.unit,
        deleteEntry: true,
        skid: dynamicData.skids
      };
    });

    const data = {
      entries,
      selectedLocation,
      taxPercentage: selectedLocation?.taxPercentage,
      discountPercentage: '0.00',
      notes: 'Deliveries after 10 am. Please ring doorbell at the back.',
      supplier: selectedSupplierName,
      supplierId: selectedSupplierInfo.supplierId,
      expectedDate: this.initDate()
    }

    if (existingPoNum) {
      data.poNumber = existingPoNum;
      data.save = true;
    }

    const callback = (status, response) => {
      if (status) {
        this.openFeedbackBar(
          'success',
          response?.isUpdated ? 'Purchase order updated' : 'Purchase order created successfully'
        );

        const newPoNum = response.poNum;

        this.setState(prevState => {
          const updatedSelections = {
            ...prevState.savedNewPOSelections,
            [col.id]: {
              ...prevState.savedNewPOSelections?.[col.id],
              poNum: newPoNum
            }
          };

        const updatedColumns = prevState.dynamicColumns.map(c =>
          c.id === col.id
            ? c.isRenamed
              ? c
              : {
                  ...c,
                  label: `New Purchase Order - ${selectedSupplierName} (${newPoNum} - ${selectedLocationName})`
                }
            : c
        );

          return {
            savedNewPOSelections: updatedSelections,
            dynamicColumns: updatedColumns
          };
        }, () => {
          this.handleSave();
        });

      } else {
        this.openFeedbackBar('error', response);
        this.refreshAllNewPurchaseOrders()
      }
    };

    this.props.automatePurchaseOrder(data,callback)
  };

  initDate = () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow
  }

  cancelEditing = () => {
    this.setState({ editingColumnId: null, editingLabel: '' });
  };

  //ftl in transit

  openFtlInTransitPopover = (e, columnId) => {
    const saved = this.state.savedFTLInTransitSelections[columnId] || [];

    const selectedTransitShipment = saved.map((ftl) => {
      if (typeof ftl === 'object' && ftl.shipmentNumber) return ftl;

      return this.props.allShippedFTL.find((s) => s.shipmentNumber === ftl) || { shipmentNumber: ftl, location: '' };
    });

    this.setState({
      ftlInTransitPopover: {
        anchorEl: e.currentTarget,
        columnId,
        selectedTransitShipment,
      },
    });
  };

  handleOpenFTLTransitSubmit = (shouldAppendNewRows = true) => {
    let {
      ftlInTransitPopover,
      pendingFTLInTransitColumn,
      dynamicColumns,
      rows: existingRows,
    } = this.state;

    const { selectedTransitShipment = [], columnId } = ftlInTransitPopover || {};
    const allShipmentNumbers = this.props.allShippedFTL || [];
    const productInventory = this.props.productInventory || [];
    const boxesInventory = this.props.boxesInventory || [];
    const combinedInventory = [...productInventory, ...boxesInventory];

    if (!pendingFTLInTransitColumn) {
      pendingFTLInTransitColumn = dynamicColumns.find(col => col.id === columnId);
    }

    const rows = existingRows.map(r => ({
      ...r,
      dynamic: r.dynamic[columnId]
        ? r.dynamic
        : { ...r.dynamic, [columnId]: { unit: '', skids: '' } },
    }));

    const ftlItemsByShortcode = {};

    selectedTransitShipment.forEach(number => {
      const ftlShipmentNumber = allShipmentNumbers.find(p => p.shipmentNumber === number.shipmentNumber);
      if (!ftlShipmentNumber) return;

      (ftlShipmentNumber.items || []).forEach(item => {
        if (!item.shortcode) return;

        const shortcode = item.shortcode;
        const unit = parseFloat(item.quantity ?? 0);
        const skids = parseFloat(item.numOfSkids ?? 0);

        if (!ftlItemsByShortcode[shortcode]) {
          ftlItemsByShortcode[shortcode] = { unit: 0, skids: 0 };
        }

        ftlItemsByShortcode[shortcode].unit += unit;
        ftlItemsByShortcode[shortcode].skids += skids;
      });
    });

    const selectedNames = selectedTransitShipment.map((ftl) => {
      const shipmentNumber = ftl.shipmentNumber;
      const location = ftl.location || '';

      return location ? `${shipmentNumber} (${location})` : shipmentNumber;
    });


    const newColumnName = selectedNames.length
      ? `FTL In Transit - ${selectedNames.join(', ')}`
      : 'FTL In Transit';

    const updatedPendingColumn = {
      ...pendingFTLInTransitColumn,
      label: pendingFTLInTransitColumn?.isRenamed ? pendingFTLInTransitColumn.label : newColumnName,
    };

    let nextDynamicColumns = dynamicColumns.some(col => col.id === columnId)
      ? dynamicColumns.map(col => col.id === columnId ? updatedPendingColumn : col)
      : [...dynamicColumns, updatedPendingColumn];

    Object.entries(ftlItemsByShortcode).forEach(([shortcode, { unit, skids }]) => {
      const idx = rows.findIndex(r => r.shortcode === shortcode);

      if (idx !== -1) {
        rows[idx].dynamic[columnId] = {
          unit: unit.toString(),
          skids: skids.toFixed(2),
        };
      } else {
        // Add only if shouldAppendNewRows is true
        const matched = combinedInventory.find(p => p.shortcode === shortcode);
        if (!matched || !shouldAppendNewRows) return;

        const qty = parseFloat(matched.quantity);
        const palQty = parseFloat(
          matched.details?.paleteQuantity ??
          matched.paleteQuantity ??
          matched.boxQuantity ??
          '1'
        );
        const skidsQty = (qty / palQty).toFixed(2);

        const dynamic = {};
        nextDynamicColumns.forEach(col => {
          dynamic[col.id] = col.id === columnId
            ? { unit: unit.toString(), skids: skids.toFixed(2) }
            : { unit: '', skids: '' };
        });

        rows.push({
          brand: matched.details?.brand ?? '',
          shortcode,
          quantity: qty,
          skids: skidsQty,
          dynamic,
        });
      }
    });

    const selectedShortcodes = new Set(Object.keys(ftlItemsByShortcode));
    rows.forEach(r => {
      if (!selectedShortcodes.has(r.shortcode) && r.dynamic[columnId]) {
        r.dynamic[columnId] = { unit: '', skids: '' };
      }
    });

    this.setState({
      rows,
      dynamicColumns: nextDynamicColumns,
      pendingFTLInTransitColumn: null,
      ftlInTransitPopover: { anchorEl: null, columnId: null, selectedTransitShipment: [] },
      showFTLInTransitSelector: false,
      savedFTLInTransitSelections: {
        ...this.state.savedFTLInTransitSelections,
        [columnId]: selectedTransitShipment,
      },
    });
  };

  refreshSavedFTLTransitSelections = () => {

    const { savedFTLInTransitSelections, rows: existingRows, dynamicColumns } = this.state;
    const allShippedFTL = this.props.allShippedFTL || [];
    const combinedInventory = [...this.props.productInventory, ...this.props.boxesInventory];

    const rows = [...existingRows];
    let updatedColumns = [...dynamicColumns];

    Object.entries(savedFTLInTransitSelections).forEach(([columnId, selectedFTLs]) => {

      const ftlItems = selectedFTLs.flatMap(shipment => {
        const ftl = allShippedFTL.find(p => p.shipmentNumber === shipment.shipmentNumber);
        return ftl?.items?.map(item => ({
          shortcode: item.shortcode,
          unit: parseFloat(item.quantity || 0),
          skids: parseFloat(item.numOfSkids || 0),
        })) || [];
      });


      const combinedByShortcode = {};
      for (const item of ftlItems) {
        if (!item.shortcode) continue;
        if (!combinedByShortcode[item.shortcode]) {
          combinedByShortcode[item.shortcode] = { unit: 0, skids: 0 };
        }
        combinedByShortcode[item.shortcode].unit += item.unit;
        combinedByShortcode[item.shortcode].skids += item.skids;
      }


      Object.entries(combinedByShortcode).forEach(([shortcode, values]) => {
        const { unit, skids } = values;
        const rowIndex = rows.findIndex(r => r.shortcode === shortcode);

        if (rowIndex !== -1) {
          rows[rowIndex].dynamic[columnId] = {
            unit: unit.toString(),
            skids: skids.toFixed(2),
          };
        } else {
          const matched = combinedInventory.find(p => p.shortcode === shortcode);
          if (!matched) return;

          const qty = parseFloat(matched.quantity);
          const palQty = parseFloat(
            matched.details?.paleteQuantity ??
            matched.paleteQuantity ??
            matched.boxQuantity ??
            '1'
          );
          const skidsQty = (qty / palQty).toFixed(2);

          const dynamic = {};
          updatedColumns.forEach(col => {
            dynamic[col.id] = col.id === columnId
              ? { unit: unit.toString(), skids: skids.toFixed(2) }
              : { unit: '', skids: '' };
          });

          rows.push({
            brand: matched.details?.brand || '',
            shortcode,
            quantity: qty,
            skids: skidsQty,
            dynamic,
          });
        }
      });

      rows.forEach(r => {
        if (!combinedByShortcode[r.shortcode] && r.dynamic[columnId]) {
          r.dynamic[columnId] = { unit: '', skids: '' };
        }
      });
    });

    this.setState({ rows });
  };



   //open purchase order
  openOpenPOPopover = (e, columnId) => {
    const saved = (this.state.savedOpenPOSelections[columnId] || []).map(
      po => (typeof po === 'string' ? po : po.poNumber)
    );

    this.setState({
      openPOPopover: {
        anchorEl: e.currentTarget,
        columnId,
        selectedPO: saved
      },
    });
  };

  refreshSavedOpenPOSelections = () => {

    const { savedOpenPOSelections, rows: existingRows, dynamicColumns } = this.state;
    const allPOs = this.props.openAndPartialPurchaseOrders || [];
    const combinedInventory = [...this.props.productInventory, ...this.props.boxesInventory];

    const rows = [...existingRows];
    let updatedColumns = [...dynamicColumns];

    Object.entries(savedOpenPOSelections).forEach(([columnId, selectedPOs]) => {

      const poItems = selectedPOs.flatMap(poNumber => {
        const po = allPOs.find(p => p.poNumber === poNumber);
        return po?.orderItems?.map(item => ({
          shortcode: item.shortcode,
          unit: parseFloat(item.quantityOrdered || 0),
          skids: parseFloat(item.skidsOrdered || 0),
        })) || [];
      });


      const combinedByShortcode = {};
      for (const item of poItems) {
        if (!item.shortcode) continue;
        if (!combinedByShortcode[item.shortcode]) {
          combinedByShortcode[item.shortcode] = { unit: 0, skids: 0 };
        }
        combinedByShortcode[item.shortcode].unit += item.unit;
        combinedByShortcode[item.shortcode].skids += item.skids;
      }


      Object.entries(combinedByShortcode).forEach(([shortcode, values]) => {
        const { unit, skids } = values;
        const rowIndex = rows.findIndex(r => r.shortcode === shortcode);

        if (rowIndex !== -1) {
          rows[rowIndex].dynamic[columnId] = {
            unit: unit.toString(),
            skids: skids.toFixed(2),
          };
        } else {
          const matched = combinedInventory.find(p => p.shortcode === shortcode);
          if (!matched) return;

          const qty = parseFloat(matched.quantity);
          const palQty = parseFloat(
            matched.details?.paleteQuantity ??
            matched.paleteQuantity ??
            matched.boxQuantity ??
            '1'
          );
          const skidsQty = (qty / palQty).toFixed(2);

          const dynamic = {};
          updatedColumns.forEach(col => {
            dynamic[col.id] = col.id === columnId
              ? { unit: unit.toString(), skids: skids.toFixed(2) }
              : { unit: '', skids: '' };
          });

          rows.push({
            brand: matched.details?.brand || '',
            shortcode,
            quantity: qty,
            skids: skidsQty,
            dynamic,
          });
        }
      });

      rows.forEach(r => {
        if (!combinedByShortcode[r.shortcode] && r.dynamic[columnId]) {
          r.dynamic[columnId] = { unit: '', skids: '' };
        }
      });
    });

    this.setState({ rows });
  };

  handleOpenPOSubmit = (shouldAppendNewRows = true) => {
    let {
      openPOPopover,
      pendingOpenPOColumn,
      dynamicColumns,
      rows: existingRows,
    } = this.state;

    const { selectedPO = [], columnId } = openPOPopover || {};
    const allPOs = this.props.openAndPartialPurchaseOrders || [];
    const productInventory = this.props.productInventory || [];
    const boxesInventory = this.props.boxesInventory || [];
    const combinedInventory = [...productInventory, ...boxesInventory];

    if (!pendingOpenPOColumn) {
      pendingOpenPOColumn = dynamicColumns.find(col => col.id === columnId);
    }

    const rows = existingRows.map(r => ({
      ...r,
      dynamic: r.dynamic[columnId]
        ? r.dynamic
        : { ...r.dynamic, [columnId]: { unit: '', skids: '' } },
    }));

    const poItemsByShortcode = {};

    selectedPO.forEach(poNumber => {
      const po = allPOs.find(p => p.poNumber === poNumber);
      if (!po) return;

      (po.orderItems || []).forEach(item => {
        if (!item.shortcode) return;

        const shortcode = item.shortcode;
        const unit = parseFloat(item.quantityOrdered ?? 0);
        const skids = parseFloat(item.skidsOrdered ?? 0);

        if (!poItemsByShortcode[shortcode]) {
          poItemsByShortcode[shortcode] = { unit: 0, skids: 0 };
        }

        poItemsByShortcode[shortcode].unit += unit;
        poItemsByShortcode[shortcode].skids += skids;
      });
    });

    const selectedNames = selectedPO.map(poNumber => {
      const po = allPOs.find(p => p.poNumber === poNumber);
      if (!po) return poNumber;
      const [poNum, ...rest] = po.name.split(' - ');
      return `${poNum} (${rest.join(' - ')})`;
    });

    const newColumnName = selectedNames.length
      ? `Purchase Orders - ${selectedNames.join(', ')}`
      : 'Open Purchase Orders';

    const updatedPendingColumn = {
      ...pendingOpenPOColumn,
      label: pendingOpenPOColumn?.isRenamed ? pendingOpenPOColumn.label : newColumnName,
    };

    let nextDynamicColumns = dynamicColumns.some(col => col.id === columnId)
      ? dynamicColumns.map(col => col.id === columnId ? updatedPendingColumn : col)
      : [...dynamicColumns, updatedPendingColumn];

    Object.entries(poItemsByShortcode).forEach(([shortcode, { unit, skids }]) => {
      const idx = rows.findIndex(r => r.shortcode === shortcode);

      if (idx !== -1) {
        rows[idx].dynamic[columnId] = {
          unit: unit.toString(),
          skids: skids.toFixed(2),
        };
      } else {
        // Add only if shouldAppendNewRows is true
        const matched = combinedInventory.find(p => p.shortcode === shortcode);
        if (!matched || !shouldAppendNewRows) return;

        const qty = parseFloat(matched.quantity);
        const palQty = parseFloat(
          matched.details?.paleteQuantity ??
          matched.paleteQuantity ??
          matched.boxQuantity ??
          '1'
        );
        const skidsQty = (qty / palQty).toFixed(2);

        const dynamic = {};
        nextDynamicColumns.forEach(col => {
          dynamic[col.id] = col.id === columnId
            ? { unit: unit.toString(), skids: skids.toFixed(2) }
            : { unit: '', skids: '' };
        });

        rows.push({
          brand: matched.details?.brand ?? '',
          shortcode,
          quantity: qty,
          skids: skidsQty,
          dynamic,
        });
      }
    });

    const selectedShortcodes = new Set(Object.keys(poItemsByShortcode));
    rows.forEach(r => {
      if (!selectedShortcodes.has(r.shortcode) && r.dynamic[columnId]) {
        r.dynamic[columnId] = { unit: '', skids: '' };
      }
    });

    this.setState({
      rows,
      dynamicColumns: nextDynamicColumns,
      pendingOpenPOColumn: null,
      openPOPopover: { anchorEl: null, columnId: null, selectedPO: [] },
      showPOSelector: false,
      savedOpenPOSelections: {
        ...this.state.savedOpenPOSelections,
        [columnId]: selectedPO,
      },
    });
  };


  //brand multi select

   openBrandsPopover = (e) => {
      this.setState({
        selectedBrandsPopover : {
          anchorEl : e.currentTarget,
          stage    : 'menu',
          selected : this.state.savedSelectedBrands,
        }
      });
    };

   addRowsForBrands = (brandNames) => {
    const { rows, dynamicColumns } = this.state;
    const { productInventory } = this.props;

    const existingShortcodes = new Set(rows.map(r => r.shortcode));
    const newRows = [];

    brandNames.forEach(brand => {
      productInventory
        .filter(p => p.details.brand === brand && !existingShortcodes.has(p.shortcode))
        .forEach(product => {
          const qty    = parseFloat(product.quantity);
          const skids  = (qty / parseFloat(product.details.paleteQuantity)).toFixed(2);
          const dynamic = {};
          dynamicColumns.forEach(col => {
            dynamic[col.id] = { unit: '', skids: '' };
          });

          newRows.push({
            brand,
            shortcode : product.shortcode,
            quantity  : qty,
            skids,
            dynamic,
          });
        });
    });
    if (newRows.length) {
      const updatedRows = [...rows, ...newRows];
      // Sort by shortcode ascending
      updatedRows.sort((a, b) => a.shortcode.localeCompare(b.shortcode));
      this.setState({ rows: updatedRows },()=>{
        this.refreshCurrentInventory();
      });
    }
  };


   handleAddBrandConfirm = () => {
      const { selectedBrandsPopover : { selected } } = this.state;
      this.addRowsForBrands(selected);
      this.setState({
        savedSelectedBrands   : selected,
        selectedBrandsPopover : { anchorEl:null, stage:'menu', selected:[] }
      });
    };

   handleRemoveBrandConfirm = () => {
    const { savedSelectedBrands, selectedBrandsPopover : { selected } } = this.state;
    const removed = savedSelectedBrands.filter(b => !selected.includes(b));

    const rows = this.state.rows.filter(r => !removed.includes(r.brand));

    this.setState({
      rows,
      savedSelectedBrands   : selected,
      selectedBrandsPopover : { anchorEl:null, stage:'menu', selected:[] }
    });
  };

  //new order

  newPOPopover = (e, columnId) => {
     const saved = this.state.savedNewPOSelections[columnId] || {
          selectedSupplier: '',
          selectedLocation: '',
        };

    this.setState({
      newPOPopover: {
        anchorEl: e.currentTarget,
        columnId,
        ...saved,
      },
    });
  };

  resetNewPOPopover = () => {
    this.setState({
      newPOPopover: { anchorEl: null, columnId: null, selectedSupplier: '', selectedLocation: '' },
      pendingNewPOColumn: null,
    });
  };

  handleNewPOSubmit = () => {
    const { columnId, selectedSupplier, selectedLocation } = this.state.newPOPopover;
    const pending = this.state.pendingNewPOColumn;

    if (!pending) {
      this.setState(prev => {
        const updatedColumns = prev.dynamicColumns.map(col => {

          if (col.id !== columnId) return col;

          if (col.isRenamed) return col;

          return {
            ...col,
            label: `New Purchase Order - ${selectedSupplier} (${selectedLocation})`
          };
        });

        return {
          dynamicColumns: updatedColumns,
          savedNewPOSelections: {
            ...prev.savedNewPOSelections,
            [columnId]: { selectedSupplier, selectedLocation },
          },
        };
      }, this.resetNewPOPopover);

      return;
    }

    const newColumn = {
      ...pending,
      label: `New Purchase Order - ${selectedSupplier} (${selectedLocation})`,
      isRenamed: false
    };

    this.setState(prev => ({
      dynamicColumns: [...prev.dynamicColumns, newColumn],

      rows: prev.rows.map(r => ({
        ...r,
        dynamic: { ...r.dynamic, [columnId]: { unit: '', skids: '' } },
      })),

      savedNewPOSelections: {
        ...prev.savedNewPOSelections,
        [columnId]: { selectedSupplier, selectedLocation },
      },
    }), this.resetNewPOPopover);
  };


  //drag

  handleDragStart = (e, colId) => {
    this.draggedColId = colId;
    e.dataTransfer.effectAllowed = 'move';
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  handleDrop = (e, targetColId) => {
    e.preventDefault();
    const draggedColId = this.draggedColId;
    if (draggedColId === targetColId) return;

    const { dynamicColumns } = this.state;
    const draggedIndex = dynamicColumns.findIndex(col => col.id === draggedColId);
    const targetIndex = dynamicColumns.findIndex(col => col.id === targetColId);

    const newColumns = [...dynamicColumns];
    const [draggedCol] = newColumns.splice(draggedIndex, 1);
    newColumns.splice(targetIndex, 0, draggedCol);

    this.setState({ dynamicColumns: newColumns });
    this.draggedColId = null;
  };

  //end drag

  calculateNumOfSkids = (shortcode, quantity) => {
        let product = this.props.filteredProducts.find((p) => {
            return p.shortcode === shortcode
        })
        if (!product) {
            product = this.props.filteredPackages.find((p) => {
                return p.shortcode === shortcode
            })
        }
        if (!product) {
            return "0.00"
        }
        let paleteQuantity = product.paleteQuantity
        return Number((quantity / paleteQuantity)) || (quantity / paleteQuantity === 0) ?
            (quantity / paleteQuantity).toFixed(2).toString() :
            (quantity / paleteQuantity).toString()
  }

  autoPlan = (colId) => {
    const daysToCover = this.state.savedProductRequirements?.[colId]?.daysToCover;
    if (!colId || !daysToCover) return;

    const summary = this.state.inventorySummaryForFTL?.[colId] || {};
    const {
        fromAddressProductInventory = [],
        fromAddressBoxInventory = [],
        toAddressProductInventory = [],
        toAddressBoxInventory = []
    } = summary;

    const resetRows = this.state.rows.map(r => ({
        ...r,
        dynamic: {
            ...r.dynamic,
            [colId]: { unit: '', skids: '', daysOfCoverage: 0 }
        }
    }));

    let itemToTransfer = [];

    const selectedTransitShipments =
        this.state.savedProductRequirements?.[colId]?.selectedTransitShipment || [];

    let totalFtlQuantityMap = {};

    selectedTransitShipments.forEach(fltObj => {
        const ftlShipment = this.props.allShippedFTL?.find(
            f => f.fullTruckloadId === fltObj.fullTruckloadId
        );
        if (ftlShipment?.items) {
            ftlShipment.items.forEach(item => {
                const qty = parseFloat(item.quantity) || 0;
                totalFtlQuantityMap[item.shortcode] =
                    (totalFtlQuantityMap[item.shortcode] || 0) + qty;
            });
        }
    });

    // --- Product Inventory
    toAddressProductInventory.forEach(product => {
        const quantity = parseFloat(product.quantity) || 0;
        const runningRate = parseFloat(product.runningRate) || 0;
        const boxQty = parseFloat(product.boxQuantity) || 1;
        const shortcode = product.shortcode;

        const toAddressDaysOfCoverage = Math.floor(quantity / runningRate);
        const uncoverDays = daysToCover - toAddressDaysOfCoverage;

        if (uncoverDays > 0) {
            let unitToTransfer = Math.ceil(daysToCover * runningRate - quantity);
            if (unitToTransfer % boxQty !== 0) unitToTransfer += boxQty - (unitToTransfer % boxQty);

            const ftlQty = totalFtlQuantityMap[shortcode] || 0;
            unitToTransfer -= ftlQty;
            if (unitToTransfer < 0) unitToTransfer = 0;

            const productFrom = fromAddressProductInventory.find(p => p.productId === product.productId);
            if (productFrom) {

               const unitInHandAfterTransfer = quantity + unitToTransfer + ftlQty;
                itemToTransfer.push({
                    shortcode,
                    quantity: unitToTransfer,
                    numOfSkids: this.calculateNumOfSkids(shortcode, unitToTransfer),
                    unitInHandAfterTransfer,
                    daysOfCoverageAfterTransfer: runningRate
                        ? Math.floor(unitInHandAfterTransfer / runningRate)
                        : 0,
                    isSample: false
                });
            }
        }
    });

    // --- Box Inventory
    toAddressBoxInventory.forEach(box => {
        const quantity = parseFloat(box.quantity) || 0;
        const runningRate = parseFloat(box.runningRate) || 0;
        const shortcode = box.shortcode;

        const toAddressDaysOfCoverage = Math.floor(quantity / runningRate);
        const uncoverDays = daysToCover - toAddressDaysOfCoverage;

        if (uncoverDays > 0) {
            let unitToTransfer = Math.ceil(daysToCover * runningRate - quantity);
            const ftlQty = totalFtlQuantityMap[shortcode] || 0;
            unitToTransfer -= ftlQty;
            if (unitToTransfer < 0) unitToTransfer = 0;

            const boxFrom = fromAddressBoxInventory.find(b => b.boxId === box.boxId);
            if (boxFrom) {
                const unitInHandAfterTransfer = quantity + unitToTransfer  + ftlQty
                itemToTransfer.push({
                    shortcode,
                    quantity: unitToTransfer,
                    numOfSkids: this.calculateNumOfSkids(shortcode, unitToTransfer),
                    unitInHandAfterTransfer,
                    daysOfCoverageAfterTransfer: runningRate
                        ? Math.floor(unitInHandAfterTransfer / runningRate)
                        : 0,
                    isSample: false
                });
            }
        }
    });

    // --- Update rows
    const newRows = [...resetRows];

    const getOrCreateRow = shortcode => {
        let row = newRows.find(r => r.shortcode === shortcode);
        if (!row) {
            row = { brand: '', shortcode, quantity: '', skids: '', dynamic: {} };
            newRows.push(row);
        }
        return row;
    };

    const masterInventory = [...(this.props.productInventory || []), ...(this.props.boxesInventory || [])];

    itemToTransfer.forEach(item => {
        const row = getOrCreateRow(item.shortcode);

        row.dynamic = {
            ...row.dynamic,
            [colId]: {
                unit: item.quantity.toString(),
                skids: item.numOfSkids,
                daysOfCoverage: item.daysOfCoverageAfterTransfer // ✅ added
            }
        };

        const matched = masterInventory.find(inv => inv.shortcode === item.shortcode);
        if (matched) {
            const qty = parseFloat(matched.quantity);
            const palQty = parseFloat(
                matched.details?.paleteQuantity ?? matched.paleteQuantity ?? matched.boxQuantity ?? '1'
            );
            row.quantity = qty.toString();
            row.skids = (qty / palQty).toFixed(2);
        }
    });

    this.setState({ rows: newRows });
};

  handleRefresh = async () => {
    const { savedProductRequirements } = this.state;
    const {
      availableLocations,
      fromLocation,
      getInventorySummaryForFTL,
      listAllOpenAndPartialPurchaseOrders,
      listShippedFTLs
    } = this.props;

    this.refreshAllNewPurchaseOrders();

    for (const [columnId, { location, daysOfCoverateBaseOn }] of Object.entries(savedProductRequirements)) {
      const transferTo = availableLocations.find((l) => l.name === location)?.shipAddressId ?? null;

      await new Promise((resolve) => this.setState({ latestProductRequirementColumn: columnId }, resolve));

      await getInventorySummaryForFTL(
        {
          transferFrom: fromLocation.shipAddressId,
          transferTo,
          daysOfCoverateBaseOn,
        },
        columnId
      );
    }

    if (typeof listAllOpenAndPartialPurchaseOrders === 'function') {
      await listAllOpenAndPartialPurchaseOrders();
    }

     if (typeof listShippedFTLs === 'function') {
      await listShippedFTLs();
    }

    this.fetchLatestBoxAndProducts();


  };

  refreshCurrentInventory = ()=>{
    const { rows, savedCurrentInventorySelections } = this.state;
    const {
      productInventory,
      boxesInventory,
    } = this.props;

    const updatedRows = rows.map((row) => {
      const combinedInventory = [...productInventory, ...boxesInventory];
      const latest = combinedInventory.find((item) => item.shortcode === row.shortcode);

      if (latest) {
        let daysOfCoverage = ""

        const numberOfDaysCovered = savedCurrentInventorySelections['currentInventory'] || 0;

        switch (numberOfDaysCovered) {
            case 7:
                daysOfCoverage = Math.floor(parseFloat(latest.quantity) / parseFloat(latest.runningRateFor7Days))
                break
            case 14:
                daysOfCoverage = Math.floor(parseFloat(latest.quantity) / parseFloat(latest.runningRateFor14Days))
                break
            case 21:
                daysOfCoverage = Math.floor(parseFloat(latest.quantity) / parseFloat(latest.runningRateFor21Days))
                break
            case 28:
                daysOfCoverage = Math.floor(parseFloat(latest.quantity) / parseFloat(latest.runningRateFor28Days))
                break
            default:
                break
        }

        daysOfCoverage = daysOfCoverage.toString() !== "NaN" ? daysOfCoverage : NO_RUNNING_RATE_MESSAGE

          const quantity = parseFloat(latest.quantity);
          const skids = (quantity / parseFloat(latest.details.paleteQuantity)).toFixed(2);

          return {
            ...row,
            quantity,
            skids,
            daysOfCoverage
          };
      }

      return row;
    });
    this.setState({ rows: updatedRows })
  }

  //product requirement


  openProductRequirementPopover = (e, columnId) => {
    const saved = this.state.savedProductRequirements[columnId] || {
      location: '',
      daysToCover: '',
      daysOfCoverateBaseOn: '',
      selectedTransitShipment: [],
    };

    this.setState({
      productRequirementPopover: {
        anchorEl: e.currentTarget,
        columnId,
        ...saved,
      },
    });
  };


  closeProductRequirementPopover = () => {
    this.setState({
      productRequirementPopover: {
        anchorEl: null,
        columnId: null,
        location: '',
        daysToCover: '',
        daysOfCoverateBaseOn: '',
      },
        pendingProductRequirementColumn: null,
    });
  };


  handleProductRequirementSubmit = () => {
    const { columnId, location, daysToCover, daysOfCoverateBaseOn, selectedTransitShipment } =
      this.state.productRequirementPopover;
    const previousDraftId = this.state.savedProductRequirements?.[columnId]?.fltDraftId;

    const updatedSaved = {
    ...this.state.savedProductRequirements,
    [columnId]: { location, daysToCover,selectedTransitShipment, daysOfCoverateBaseOn,  ...(previousDraftId && { fltDraftId: previousDraftId }) },
  };


  const columnExists = this.state.dynamicColumns.some(c => c.id === columnId);

  const dynamicColumns = columnExists
    ? this.state.dynamicColumns.map(c =>
        c.id === columnId ? { ...c, label: `Product Requirements (${location})` } : c)
    : [
        ...this.state.dynamicColumns,
        {
          id: columnId,
          type: 'Product Requirements',
          label: `Product Requirements (${location})`,
          isProductRequirement: true,
        },
    ];

  const rows = columnExists
    ? this.state.rows
    : this.state.rows.map(r => ({
        ...r,
        dynamic: { ...r.dynamic, [columnId]: { unit: '', skids: '' } },
      }));

    const transferTo = this.props.availableLocations.find(l => l.name === location)?.shipAddressId ?? null;


      this.setState(
        {
          dynamicColumns,
          rows,
          savedProductRequirements: updatedSaved,
          latestProductRequirementColumn: columnId,
          pendingProductRequirementColumn: null,
          showAppendPrompt: true,
          pendingAutoPlanColumnId: columnId,
          pendingTransferRequest: {
            transferFrom: this.props.fromLocation.shipAddressId,
            transferTo,
            daysOfCoverateBaseOn,
          },
        },
        this.closeProductRequirementPopover
      );
  };


  fetchInventorySummaryForFTL = async () => {
    const { savedProductRequirements} = this.state;
    const {
      availableLocations,
      fromLocation,
      getInventorySummaryForFTL,
    } = this.props;

    for (const [columnId, { location, daysOfCoverateBaseOn }] of Object.entries(savedProductRequirements)) {
      const transferTo = availableLocations.find((l) => l.name === location)?.shipAddressId ?? null;

      await new Promise((resolve) => this.setState({ latestProductRequirementColumn: columnId }, resolve));
      await getInventorySummaryForFTL(
        {
          transferFrom: fromLocation.shipAddressId,
          transferTo,
          daysOfCoverateBaseOn,
        },
        columnId
      );
    }

  }

  updateDynamicValue = (rowIndex, colId, field, value) => {
    this.setState(prevState => {
      const rows = [...prevState.rows];
      const row = rows[rowIndex];

      const updatedDynamic = {
        ...(row.dynamic || {}),
        [colId]: {
          ...(row.dynamic?.[colId] || {}),
          [field]: value
        }
      };

      rows[rowIndex] = {
        ...row,
        dynamic: updatedDynamic
      };

      return { rows };
    });
  };


  handleDynamicValueBlur = (rowIndex, colId, field, value) => {
    this.setState(prevState => {
      const rows = [...prevState.rows];
      const row = rows[rowIndex];

      const masterInventory = [
        ...(this.props.productInventory || []),
        ...(this.props.boxesInventory || [])
      ];

      const matched = masterInventory.find(p => p.shortcode === row.shortcode);
      const paleteQty = parseFloat(
        matched?.details?.paleteQuantity ??
        matched?.paleteQuantity ??
        matched?.boxQuantity ??
        '0'
      );

      let newUnit = row.dynamic?.[colId]?.unit || '';
      let newSkids = row.dynamic?.[colId]?.skids || '';

      if (field === 'unit') {
        const unitNum = parseFloat(value);
        if (!isNaN(unitNum) && paleteQty) {
          newUnit = unitNum.toString();
          newSkids = (unitNum / paleteQty).toFixed(2);
        } else {
          newUnit = '';
          newSkids = '';
        }
      } else if (field === 'skids') {
        const skidsNum = parseFloat(value);
        if (!isNaN(skidsNum) && paleteQty) {
          newSkids = skidsNum.toString();
          newUnit = Math.round(skidsNum * paleteQty).toString();
        } else {
          newUnit = '';
          newSkids = '';
        }
      }


      let newDaysOfCoverage = 0;
      const requirement = prevState.savedProductRequirements?.[colId];
      const summary = this.state.inventorySummaryForFTL?.[colId] || {};

      if (requirement && matched && paleteQty) {
        const {
          toAddressProductInventory = [],
          toAddressBoxInventory = [],
        } = summary;

        const updatedQty = parseFloat(newUnit || 0);

        const selectedTransitShipments = requirement?.selectedTransitShipment || [];
        let totalFtlQuantity = 0;

        selectedTransitShipments.forEach(fltObj => {
        const ftlShipment = this.props.allShippedFTL?.find(
            ftl => ftl.fullTruckloadId === fltObj.fullTruckloadId
        );
        if (ftlShipment?.items) {
            ftlShipment.items.forEach(item => {
              if (item.shortcode === row.shortcode) {
                totalFtlQuantity += parseFloat(item.quantity) || 0;
              }
            });
          }
        });

        toAddressProductInventory.forEach(product => {
          if (product.shortcode !== row.shortcode) return;
          const quantity = parseFloat(product.quantity);
          const runningRate = parseFloat(product.runningRate) || 0;
          if (runningRate > 0) {
            newDaysOfCoverage = Math.floor((quantity + updatedQty + totalFtlQuantity) / runningRate);
          }
        });

        toAddressBoxInventory.forEach(box => {
          if (box.shortcode !== row.shortcode) return;
          const quantity = parseFloat(box.quantity);
          const runningRate = parseFloat(box.runningRate) || 0;
          if (runningRate > 0) {
            newDaysOfCoverage = Math.floor((quantity + updatedQty + totalFtlQuantity) / runningRate);
          }
        });
      }

      rows[rowIndex].dynamic = {
        ...(row.dynamic || {}),
        [colId]: {
          ...(row.dynamic?.[colId] || {}),
          unit: newUnit,
          skids: newSkids,
          ...(newDaysOfCoverage > 0 ? { daysOfCoverage: newDaysOfCoverage } : {})
        }
      };

      return { rows };
    });
  };

  displayUnitAndCoverageAfterTransferToLocation = (unit, skids, daysOfCoverage) => {
    if ((!unit || parseFloat(unit) === 0) &&
        (!skids || parseFloat(skids) === 0)) return null;

    if (!daysOfCoverage || parseFloat(daysOfCoverage) === 0) return null;

    return <div>{daysOfCoverage}</div>;
  }


  handleAppendPromptAnswer = (shouldAppend) => {

    const { pendingAutoPlanColumnId, pendingTransferRequest } = this.state;

    if (!pendingAutoPlanColumnId || !pendingTransferRequest) return;


    this.props.getInventorySummaryForFTL(
      pendingTransferRequest,
      pendingAutoPlanColumnId,
      () => {
        if (shouldAppend) {
          this.autoPlan(pendingAutoPlanColumnId);
        } else {
          this.autoPlanPartial(pendingAutoPlanColumnId);
        }
      }
    );

    this.setState({
      showAppendPrompt: false,
      pendingAutoPlanColumnId: null,
      pendingTransferRequest: null,
    });
  };

  autoPlanPartial = (colId) => {
    const { savedProductRequirements } = this.state;
    if (!colId) return;

    const daysToCover = savedProductRequirements?.[colId]?.daysToCover;
    if (!daysToCover) return;

    const currentRows = this.state.rows;

    const summary = this.state.inventorySummaryForFTL?.[colId] || {};
    const {
      fromAddressProductInventory = [],
      fromAddressBoxInventory = [],
      toAddressProductInventory = [],
      toAddressBoxInventory = []
    } = summary;

    const newRows = currentRows.map(row => {
      const key = colId; // current column
      let updatedUnit = row.dynamic[key]?.unit;
      let updatedSkids = row.dynamic[key]?.skids;
      let updatedDaysOfCoverage = row.dynamic[key]?.daysOfCoverage;

      const selectedTransitShipments = savedProductRequirements?.[key]?.selectedTransitShipment || [];
      let totalFtlQuantity = 0;

      selectedTransitShipments.forEach(fltObj => {
        const ftlShipment = this.props.allShippedFTL?.find(
          ftl => ftl.fullTruckloadId === fltObj.fullTruckloadId
        );

        if (ftlShipment?.items) {
          ftlShipment.items.forEach(item => {
            if (item.shortcode === row.shortcode) {
              totalFtlQuantity += parseFloat(item.quantity) || 0;
            }
          });
        }
      });

      let runningRateForDays = 0;

      toAddressProductInventory.forEach(product => {
        if (product.shortcode !== row.shortcode) return;

        const quantity = parseFloat(product.quantity) || 0;
        const runningRate = parseFloat(product.runningRate) || 0;
        const boxQty = parseFloat(product.boxQuantity) || 0;

        runningRateForDays = runningRate;

        const toAddressDaysOfCoverage = Math.floor(quantity / runningRate);
        const uncoverDays = daysToCover - toAddressDaysOfCoverage;

        if (uncoverDays > 0) {
          let unitToTransfer = Math.ceil(daysToCover * runningRate - quantity);

          if (boxQty > 0 && unitToTransfer % boxQty !== 0) {
            unitToTransfer += boxQty - (unitToTransfer % boxQty);
          }

          unitToTransfer -= totalFtlQuantity;
          if (unitToTransfer < 0) unitToTransfer = 0;

          const productFrom = fromAddressProductInventory.find(
            p => p.productId === product.productId
          );

          if (productFrom) {
            const unitInHandAfterTransfer = quantity + unitToTransfer + totalFtlQuantity;
            updatedDaysOfCoverage = runningRate
              ? Math.floor(unitInHandAfterTransfer / runningRate)
              : 0;
            updatedUnit = unitToTransfer.toString();
            updatedSkids = this.calculateNumOfSkids(product.shortcode, unitToTransfer);
          }
        }
      });

      toAddressBoxInventory.forEach(box => {
        if (box.shortcode !== row.shortcode) return;

        const quantity = parseFloat(box.quantity) || 0;
        const runningRate = parseFloat(box.runningRate) || 0;

        runningRateForDays = runningRate;

        const toAddressDaysOfCoverage = Math.floor(quantity / runningRate);
        const uncoverDays = daysToCover - toAddressDaysOfCoverage;

        if (uncoverDays > 0) {
          let unitToTransfer = Math.ceil(daysToCover * runningRate - quantity);

          unitToTransfer -= totalFtlQuantity;
          if (unitToTransfer < 0) unitToTransfer = 0;

          const boxFrom = fromAddressBoxInventory.find(b => b.boxId === box.boxId);

          if (boxFrom) {

            updatedUnit = unitToTransfer.toString();
            updatedSkids = this.calculateNumOfSkids(box.shortcode, unitToTransfer);
             const unitInHandAfterTransfer = quantity + unitToTransfer + totalFtlQuantity;
            updatedDaysOfCoverage = runningRate
              ? Math.floor(unitInHandAfterTransfer / runningRate)
              : 0;
          }
        }
      });

      return {
        ...row,
        dynamic: {
          ...row.dynamic,
          [key]: {
            ...row.dynamic[key],
            unit: updatedUnit,
            skids: updatedSkids,
            daysOfCoverage: updatedDaysOfCoverage
          }
        }
      };
    });
    this.setState({ rows: newRows }, () => {
      this.refreshCurrentInventory();
    });
  };

  //end product requirement


  openColumnTypePopover = (e) => {
    this.setState({ columnTypeAnchorEl: e.currentTarget });
  };

  closeColumnTypePopover = () => {
    this.setState({ columnTypeAnchorEl: null });
  };

  //shortcode
  handleShortcodeChange = (rowIndex, value) => {
    const rows = [...this.state.rows];

    if (value) {
      const combinedInventory = [...this.props.productInventory, ...this.props.boxesInventory];
      const selected = combinedInventory.find((p) => p.shortcode === value);

      if (selected) {
        const qty = parseFloat(selected.quantity);
        const skids = (qty / parseFloat(selected.details.paleteQuantity)).toFixed(2);

        let daysOfCoverage = '';
        const savedCurrentInventorySelections = this.state.savedCurrentInventorySelections || {};
        const numberOfDaysCovered = savedCurrentInventorySelections['currentInventory'] || 0;

        switch (numberOfDaysCovered) {
          case 7:
            daysOfCoverage = Math.floor(qty / parseFloat(selected.runningRateFor7Days));
            break;
          case 14:
            daysOfCoverage = Math.floor(qty / parseFloat(selected.runningRateFor14Days));
            break;
          case 21:
            daysOfCoverage = Math.floor(qty / parseFloat(selected.runningRateFor21Days));
            break;
          case 28:
            daysOfCoverage = Math.floor(qty / parseFloat(selected.runningRateFor28Days));
            break;
          default:
            daysOfCoverage = '';
            break;
        }

        rows[rowIndex] = {
          ...rows[rowIndex],
          shortcode: value,
          quantity: qty,
          skids: skids,
          daysOfCoverage: daysOfCoverage,
          dynamic: { ...rows[rowIndex].dynamic }
        };
      }
    } else {
      rows[rowIndex] = {
        ...rows[rowIndex],
        shortcode: '',
        quantity: '',
        skids: '',
        daysOfCoverage: '',
        dynamic: Object.fromEntries(
          this.state.dynamicColumns
            .filter(col => col.isProductRequirement)
            .map(col => [col.id, { unit: '', skids: '', daysOfCoverage: '' }])
        )
      };
    }

    this.setState({ rows });
  };


  addRow = () => {
    const newRow = {
      brand: '',
      shortcode: '',
      quantity: '',
      skids: '',
      dynamic: {},
    };
    this.state.dynamicColumns.forEach((col) => {
      newRow.dynamic[col.id] = { unit: '', skids: '' };
    });
    this.setState((prev) => ({ rows: [...prev.rows, newRow] }));
  };

  removeRow = (index) => {
    const rows = [...this.state.rows];
    rows.splice(index, 1);
    this.setState({ rows });
  };

  addDynamicColumn = (type) => {
    if (type === 'Open Purchase Orders') {
      const id = generateId();

      this.setState(prev => ({
        pendingOpenPOColumn: {
          id,
          type,
          label: type,
          isProductRequirement: false,
          isRenamed: false
        },

        openPOPopover: {
          anchorEl: prev.columnTypeAnchorEl,
          columnId: id,
          selectedPO: [],
        },
      }), this.closeColumnTypePopover);

      return;
    }

    if (type === 'Product Requirements') {
        const id = generateId();

        this.setState(prev => ({
          pendingProductRequirementColumn: {
            id,
            type,
            label: type,
            isProductRequirement: true,
          },
          productRequirementPopover: {
            anchorEl: prev.columnTypeAnchorEl,
            columnId: id,
            location: '',
            daysToCover: '',
            daysOfCoverateBaseOn: '',
          },
        }), this.closeColumnTypePopover);

        return;
      }

    if (type === 'New Purchase Orders') {
      const id = generateId();

      this.setState(prev => ({
        pendingNewPOColumn: { id, type, label: type, isProductRequirement: false, isRenamed: false },
        newPOPopover: {
          anchorEl: prev.columnTypeAnchorEl,
          columnId: id,
          selectedSupplier: '',
          selectedLocation: '',
        },
      }), this.closeColumnTypePopover);

      return
    }

    if (type === 'FTL In Transit') {
      const id = generateId();

      this.setState(prev => ({
        pendingFTLInTransitColumn: {
          id,
          type,
          label: type,
          isProductRequirement: false,
          isRenamed: false
        },

       ftlInTransitPopover: {
          anchorEl: prev.columnTypeAnchorEl,
          columnId: id,
          selectedTransitShipment: [],
        },
      }), this.closeColumnTypePopover);

      return;
    }



    const id = generateId();
    const newColumn = { id, type, label: type, isProductRequirement: false, isRenamed: false };

    this.setState(prev => ({
      dynamicColumns: [...prev.dynamicColumns, newColumn],
      rows: prev.rows.map(row => ({
        ...row,
        dynamic: { ...row.dynamic, [id]: { unit: '', skids: '' } },
      })),
    }), this.closeColumnTypePopover);
  };

  removeDynamicColumn = (colId) => {
    this.setState(prev => {

      const dynamicColumns = prev.dynamicColumns.filter(col => col.id !== colId);

      const rows = prev.rows.map(row => {
        const { [colId]: _discard, ...dynamic } = row.dynamic;
        return { ...row, dynamic };
      });

      const { [colId]: _pr, ...savedProductRequirements } = prev.savedProductRequirements || {};
      const { [colId]: _op, ...savedOpenPOSelections }   = prev.savedOpenPOSelections || {};
      const { [colId]: _np, ...savedNewPOSelections }    = prev.savedNewPOSelections || {};
       const { [colId]: _fl, ...savedFTLInTransitSelections }    = prev.savedFTLInTransitSelections || {};

      return {
        dynamicColumns,
        rows,
        savedProductRequirements,
        savedOpenPOSelections,
        savedNewPOSelections,
        savedFTLInTransitSelections
      };
    });
  };


  updateHeaderLabel = (colId, label) => {
    const dynamicColumns = this.state.dynamicColumns.map((col) =>
      col.id === colId ? { ...col, label } : col
    );
    this.setState({ dynamicColumns });
  };

  handleSave =() =>{

      const { rows, dynamicColumns, savedCurrentInventorySelections,savedOpenPOSelections,savedFTLInTransitSelections, planName, savedProductRequirements, savedSelectedBrands, savedNewPOSelections } = this.state;


      const isSaveDisabled =
        !(planName || '').trim() ||
        rows.length === 0 ||
        rows.some(r => !(r.shortcode || '').trim())


        if(isSaveDisabled){
          return
        }

        const callback = (status, orderPlanningId) => {
          if (status) {
            this.setState({orderPlanningId })
          }
        };

        const filters= {
                            showUnits: this.state.showUnits,
                            showSkids: this.state.showSkids,
                            sortDirection: this.state.sortDirection,
        }

        const data = {
                            rows,
                            dynamicColumns,
                            savedOpenPOSelections,
                            savedFTLInTransitSelections,
                            savedProductRequirements,
                            savedSelectedBrands,
                            savedNewPOSelections,
                            planName,
                            savedCurrentInventorySelections,
                            orderPlanningId: this.state.orderPlanningId,
                            locationId: this.props.fromLocation.shipAddressId,
                            filters

        }

        this.props.saveOrderPlanning(data,callback)
  }

  handleSubmit = () => {
       this.handleSave()
       this.props.cancel()
  }

  getTotalsRow = () => {
    const total = {
      brand: 'TOTAL',
      shortcode: '',
      quantity: 0,
      skids: 0,
      dynamic: {}
    };

    this.state.dynamicColumns.forEach((col) => {
      total.dynamic[col.id] = { unit: 0, skids: 0 };
    });

    this.state.rows.forEach((row) => {

      const quantity = parseFloat(row.quantity);
      if (!isNaN(quantity)) {
        total.quantity += quantity;
      }

      const skids = parseFloat(row.skids);
      if (!isNaN(skids)) {
        total.skids += skids;
      }

      this.state.dynamicColumns.forEach((col) => {
        const dyn = row.dynamic[col.id];
        if (dyn) {
          const unit = parseFloat(dyn.unit);
          const dynSkids = parseFloat(dyn.skids);

          if (!isNaN(unit)) {
            total.dynamic[col.id].unit += unit;
          }
          if (!isNaN(dynSkids)) {
            total.dynamic[col.id].skids += dynSkids;
          }
        }
      });
    });

    total.skids = total.skids.toFixed(2);
    total.quantity = total.quantity.toFixed(0);

    this.state.dynamicColumns.forEach((col) => {
      total.dynamic[col.id].skids = total.dynamic[col.id].skids.toFixed(2);
    });

    return total;
  };

  onDragStartRow = (index) => {
    this.setState({ draggedRowIndex: index });
  };

  onDropRow = (index) => {
    const { draggedRowIndex, rows } = this.state;
    if (draggedRowIndex === null || draggedRowIndex === index) return;

    const updatedRows = [...rows];
    const [movedRow] = updatedRows.splice(draggedRowIndex, 1);
    updatedRows.splice(index, 0, movedRow);

    this.setState({ rows: updatedRows, draggedRowIndex: null });
  };


  handleRefreshClick = () => {
    this.setState({ openConfirmDialog: true });
  };

  handleConfirm = () => {
    this.setState({ openConfirmDialog: false },()=>{
        this.handleRefresh()
    });
  };

  handleCancel = () => {
    this.setState({ openConfirmDialog: false });
  };


  render() {

    const {
      planName,
      rows,
      dynamicColumns,
      columnTypeAnchorEl,
      editingColumnId,
      editingLabel,
    } = this.state;

    const fixedColumns = '0px 320px 300px';
    const dynamicColumnWidth = 300;
    const dynamicColumnsCount = Math.max(dynamicColumns.length, 1);
    const gridTemplateColumns = `${fixedColumns} repeat(${dynamicColumnsCount}, ${dynamicColumnWidth}px) 300px`;

    const isSaveDisabled =
      !(planName || '').trim() ||
      rows.length === 0 ||
      rows.some((r) => !(r.shortcode || '').trim());

    const btnStyle = {
      backgroundColor: '#005E73',
      color: '#fff',
      border: 'none',
      borderRadius: 4,
      padding: '8px 16px',
      cursor: 'pointer',
      width: '100%',
    };

    const menuItems = [
      {
        title: BACK_BUTTON,
        icon: <KeyboardBackspaceIcon />,
        onClick: this.props.cancel,
      },
      {
        title: 'Save',
        icon: <SaveIcon />,
        onClick: this.handleSubmit,
        disabled: isSaveDisabled,
      },
      {
        title: 'Refresh',
        icon: <RefreshIcon />,
        onClick: this.handleRefreshClick,
      },
    ];

    const totalRow = this.getTotalsRow();

    return (
      <React.Fragment>
        <TopToolbar
          pageName={`Order Planning - ${this.props.fromLocation.name}`}
          menuItems={menuItems}
        />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.status === 'success' ? 'success' : 'error'}
          message={this.state.message}
        />

        <div className="order-container">

           <Dialog open={this.state.openConfirmDialog} onClose={this.handleCancel}>
            <DialogTitle>Confirm Refresh</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Refresh will revise the Current Inventory, Product Requirements and New Purchase Orders column. Would you like to continue?
              </DialogContentText>
            </DialogContent>

              <DialogActions>
                <div className="save-cancel-buttons">
                  <Button
                    variant="contained"
                    onClick={this.handleCancel}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: '16px', marginRight: '16px' }}
                    onClick={this.handleConfirm}
                  >
                    Yes
                  </Button>
                </div>
              </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.showAppendPromptPO}
            onClose={() => this.setState({ showAppendPromptPO: false })}
          >
            <DialogTitle>Append Products?</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Would you like to append the products not currently in your
                planning sheet?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <div className="save-cancel-buttons">
                <Button
                  variant="contained"
                  onClick={() => {
                    this.setState({ showAppendPromptPO: false }, () => {
                      if (this.state.onPOAppendConfirm) {
                        this.state.onPOAppendConfirm(false); // No
                      }
                    });
                  }}
                >
                  No
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: '16px', marginRight: '16px' }}
                  onClick={() => {
                    this.setState({ showAppendPromptPO: false }, () => {
                      if (this.state.onPOAppendConfirm) {
                        this.state.onPOAppendConfirm(true); // No
                      }
                    });
                  }}
                >
                  Yes
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.showAppendPrompt}
            onClose={() => this.setState({ showAppendPrompt: false })}
          >
            <DialogTitle>Append Products</DialogTitle>
            <DialogContent>
              Would you like to append the products not currently in your
              planning sheet?
            </DialogContent>
            <DialogActions>
              <div className="save-cancel-buttons">
                <Button
                  onClick={() => this.handleAppendPromptAnswer(false)}
                  variant="contained"
                >
                  No
                </Button>

                <Button
                  style={{ marginLeft: '16px', marginRight: '16px' }}
                  onClick={() => this.handleAppendPromptAnswer(true)}
                  variant="contained"
                  color="primary"
                >
                  Yes
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          {/*//ftl dialog*/}

          <Dialog
            open={this.state.showAppendPromptFTL}
            onClose={() => this.setState({ showAppendPromptFTL: false })}
          >
            <DialogTitle>Append Products?</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Would you like to append the products not currently in your
                planning sheet?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <div className="save-cancel-buttons">
                <Button
                  variant="contained"
                  onClick={() => {
                    this.setState({ showAppendPromptFTL: false }, () => {
                      if (this.state.ftlAppendConfirm) {
                        this.state.ftlAppendConfirm(false); // No
                      }
                    });
                  }}
                >
                  No
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: '16px', marginRight: '16px' }}
                  onClick={() => {
                    this.setState({ showAppendPromptFTL: false }, () => {
                      if (this.state.ftlAppendConfirm) {
                        this.state.ftlAppendConfirm(true); // No
                      }
                    });
                  }}
                >
                  Yes
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          <div className="plan-header">
            <TextField
              variant="outlined"
              name="planName"
              label="Plan Name"
              value={this.state.planName}
              onChange={(e) => this.setState({ planName: e.target.value })}
              style={{ width: '250px' }}
            />
          </div>

          <div className="box-form-control">
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.showUnits}
                  onChange={(e) =>
                    this.setState({ showUnits: e.target.checked })
                  }
                  style={{ color: '#acd685' }}
                />
              }
              label="Show Units"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.showSkids}
                  style={{ color: '#acd685' }}
                  onChange={(e) =>
                    this.setState({ showSkids: e.target.checked })
                  }
                />
              }
              label="Show Skids"
            />
          </div>

          <div className="table-scroll-container">
            <div className="table">
              <div className="table-header" style={{ gridTemplateColumns }}>
                <div className="header-icon table-horizontal-divider" />
                <div className="header-shortcode header-divider table-horizontal-divider">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                      position: 'relative',
                    }}
                  >
                    <div style={{ flex: 1 }}></div>

                    <div
                      style={{
                        position: 'absolute',
                        left: '50%',
                        marginLeft: '-24px',
                        transform: 'translateX(-50%)',
                      }}
                    >
                      Shortcode
                      <IconButton
                        size="small"
                        onClick={this.toggleShortcodeSort}
                        style={{
                          padding: 0,
                          marginLeft: '8px',
                          marginTop: '-2px',
                        }}
                      >
                        {this.state.sortDirection === 'asc' ? (
                          <ArrowUpwardIcon fontSize="small" />
                        ) : this.state.sortDirection === 'desc' ? (
                          <ArrowDownwardIcon fontSize="small" />
                        ) : (
                          <ArrowUpwardIcon
                            fontSize="small"
                            style={{ opacity: 0.3 }}
                          />
                        )}
                      </IconButton>
                    </div>

                    <IconButton
                      style={{ marginRight: '8px' }}
                      size="small"
                      onClick={this.openBrandsPopover}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </div>
                </div>

                <div
                  className="header-inventory header-divider table-horizontal-divider"
                  style={{ position: 'relative' }}
                >
                  <div style={{ marginTop: '26px' }}>
                    Current Inventory
                    <br />({this.props.fromLocation?.name})
                    {/* Icon at top-right for setting days of coverage */}
                    <IconButton
                      size="small"
                      style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        cursor: 'pointer',
                        padding: 4,
                      }}
                      onClick={(e) => {
                        const savedValue =
                          this.state.savedCurrentInventorySelections[
                            'currentInventory'
                          ] || '';
                        this.setState({
                          currentInventoryPopover: {
                            anchorEl: e.currentTarget,
                            columnId: 'currentInventory',
                            daysOfCoverage: savedValue, // load saved value here
                          },
                        });
                      }}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </div>

                  <div className="sub-headers-current-inventory divider-current-inventory">
                    <div style={{ width: '100px' }}>Units</div>
                    <div style={{ width: '100px' }}>Skids</div>
                    <div style={{ width: '100px' }}>
                      Days of
                      <br />
                      Coverage
                    </div>
                  </div>

                  {/* Popover for days of coverage */}
                  {this.state.currentInventoryPopover?.anchorEl && (
                    <Popover
                      open={Boolean(
                        this.state.currentInventoryPopover.anchorEl
                      )}
                      anchorEl={this.state.currentInventoryPopover.anchorEl}
                      onClose={() =>
                        this.setState({
                          currentInventoryPopover: {
                            anchorEl: null,
                            daysOfCoverage:
                              this.state.currentInventoryPopover
                                ?.daysOfCoverage || 14,
                          },
                        })
                      }
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                      <div style={{ padding: 16, width: 200 }}>
                        <Autocomplete
                          style={{ marginBottom: 16 }}
                          options={[7, 14, 21, 28]}
                          getOptionLabel={(option) => option.toString()}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          value={
                            this.state.currentInventoryPopover
                              ?.daysOfCoverage || 14
                          }
                          onChange={(e, value) => {
                            this.setState((prev) => ({
                              currentInventoryPopover: {
                                ...prev.currentInventoryPopover,
                                daysOfCoverage: value || 14,
                              },
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Days of coverage"
                              variant="outlined"
                              required
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        />

                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={
                               !(this.state.currentInventoryPopover?.daysOfCoverage || 14)
                          }
                          onClick={() => {

                           const daysOfCoverage = this.state.currentInventoryPopover?.daysOfCoverage || 14;

                            this.setState(
                              (prev) => ({
                                savedCurrentInventorySelections: {
                                  ...prev.savedCurrentInventorySelections,
                                  ['currentInventory']: Number(daysOfCoverage),
                                },
                                currentInventoryPopover: {
                                  anchorEl: null,
                                  daysOfCoverage: daysOfCoverage,
                                },
                              }),
                              () => {
                                this.refreshCurrentInventory();
                              }
                            );
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </Popover>
                  )}
                </div>

                {dynamicColumns.map((col) => {
                  const isEditing = editingColumnId === col.id;

                  const isSaveNewPurchaseOrder =
                    this.isSaveNewPurchaseOrder(col);

                  return (
                    <div
                      key={col.id}
                      className="header-dynamic header-divider table-horizontal-divider"
                      draggable
                      onDragStart={(e) => this.handleDragStart(e, col.id)}
                      onDragOver={this.handleDragOver}
                      onDrop={(e) => this.handleDrop(e, col.id)}
                    >
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          paddingRight: '8px',
                        }}
                      >
                        {isEditing ? (
                          <Tooltip title="Save column name" arrow>
                            <IconButton
                              size="small"
                              onClick={() => this.saveColumnLabel(col)}
                            >
                              <CheckCircleIcon
                                fontSize="small"
                                color="secondary"
                              />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <>
                            <Tooltip title="Remove column" arrow>
                              <IconButton
                                size="small"
                                onClick={() => this.removeDynamicColumn(col.id)}
                              >
                                <CloseIcon fontSize="small" color="error" />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Edit column name" arrow>
                              <IconButton
                                size="small"
                                onClick={() => this.startEditingColumn(col)}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {col.type === 'New Purchase Orders' &&
                              isSaveNewPurchaseOrder && (
                                <Tooltip
                                  title={
                                    this.state.savedNewPOSelections?.[col.id]
                                      ?.poNum
                                      ? `Update PO# ${
                                          this.state.savedNewPOSelections[
                                            col.id
                                          ].poNum
                                        }`
                                      : 'Create Purchase Order'
                                  }
                                  arrow
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      this.saveNewPurchaseOrder(col)
                                    }
                                  >
                                    <CheckCircleIcon
                                      fontSize="small"
                                      color="secondary"
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}

                            {col.type === 'Product Requirements' &&
                              (() => {
                                const savedSelection =
                                  this.state.savedProductRequirements?.[col.id];
                                const fltDraftId = savedSelection?.fltDraftId;
                                const hasMatchingShipment =
                                  fltDraftId &&
                                  savedSelection?.selectedTransitShipment?.some(
                                    (s) => s.fullTruckloadId === fltDraftId
                                  );
                                // If there's a match, we need to create new draft
                                const showCreate =
                                  !fltDraftId || hasMatchingShipment;

                                return (
                                  <Tooltip
                                    title={
                                      showCreate
                                        ? 'Create FTL Draft'
                                        : 'Update FTL Draft'
                                    }
                                    arrow
                                  >
                                    <IconButton
                                      size="small"
                                      onClick={() => this.createFTLDraft(col)}
                                    >
                                      <CheckCircleIcon
                                        fontSize="small"
                                        color="secondary"
                                      />
                                    </IconButton>
                                  </Tooltip>
                                );
                              })()}

                            <IconButton size="small">
                              <MenuIcon
                                fontSize="small"
                                style={{ cursor: 'grab' }}
                              />
                            </IconButton>

                            {col.isProductRequirement && (
                              <IconButton
                                size="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) =>
                                  this.openProductRequirementPopover(e, col.id)
                                }
                              >
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                            )}

                            {col.type === 'Open Purchase Orders' && (
                              <IconButton
                                size="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) =>
                                  this.openOpenPOPopover(e, col.id)
                                }
                              >
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                            )}

                            {col.type === 'FTL In Transit' && (
                              <IconButton
                                size="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) =>
                                  this.openFtlInTransitPopover(e, col.id)
                                }
                              >
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                            )}

                            {col.type === 'New Purchase Orders' && (
                              <IconButton
                                size="small"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => this.newPOPopover(e, col.id)}
                              >
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                            )}
                          </>
                        )}
                      </div>

                      <div
                        style={{
                          width: '100%',
                          justifyContent: 'center',
                          display: 'flex',
                          alignItems: 'center',
                          textAlign: 'center',
                          flexWrap: 'wrap',
                          wordBreak: 'break-word',
                          maxWidth: '100%',
                          height: '150px',
                        }}
                      >
                        {isEditing ? (
                          <InputBase
                            autoFocus
                            value={editingLabel}
                            onChange={this.handleEditingLabelChange}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') this.saveColumnLabel(col);
                              if (e.key === 'Escape') this.cancelEditing();
                            }}
                            className="inputBase"
                            multiline
                            maxRows={2}
                          />
                        ) : (
                          <div className="colLabelName">
                            {col.label.includes('(') ? (
                              <>
                                {col.label.split('(')[0].trim()} <br />(
                                {col.label.split('(')[1]}
                              </>
                            ) : (
                              col.label
                            )}
                          </div>
                        )}
                      </div>

                      <div className="sub-headers dynamic-horizontal-bottom-divider">
                        <div
                          style={{
                            flexBasis:
                              col.type === 'Product Requirements'
                                ? '100px'
                                : '150px',
                            height:
                              col.type === 'Product Requirements'
                                ? 'auto'
                                : '36px',
                          }}
                        >
                          Units
                        </div>
                        <div
                          style={{
                            flexBasis:
                              col.type === 'Product Requirements'
                                ? '100px'
                                : '150px',
                            height:
                              col.type === 'Product Requirements'
                                ? 'auto'
                                : '36px',
                          }}
                        >
                          Skids
                        </div>
                        {col.type === 'Product Requirements' && (
                          <div style={{ flexBasis: '100px' }}>
                            Days of
                            <br />
                            Coverage
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div
                  style={{ cursor: 'pointer' }}
                  onClick={this.openColumnTypePopover}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '118px',
                      marginTop: '-24px',
                      marginLeft: '24px',
                    }}
                  >
                    <AddCircleIcon
                      fontSize="small"
                      color="secondary"
                      style={{ color: '#b0d48c', marginRight: '8px' }}
                    />
                    <span style={{ marginLeft: 4, fontWeight: 'bold' }}>
                      Add Column
                    </span>
                  </div>
                </div>
              </div>

              {rows.map((row, rowIndex) => {
                const combinedInventory = [
                  ...this.props.productInventory,
                  ...this.props.boxesInventory,
                ];

                const usedShortcodes = this.state.rows
                  .filter((_, i) => i !== rowIndex)
                  .map((r) => r.shortcode);

                const shortcodes = row.brand
                  ? combinedInventory.filter(
                      (p) =>
                        p.details.brand === row.brand &&
                        !usedShortcodes.includes(p.shortcode)
                    )
                  : combinedInventory.filter(
                      (p) => !usedShortcodes.includes(p.shortcode)
                    );

                return (
                  <div
                    key={rowIndex}
                    className="table-row"
                    style={{ gridTemplateColumns }}
                    draggable
                    onDragStart={() => this.onDragStartRow(rowIndex)}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={() => this.onDropRow(rowIndex)}
                  >
                    <div className="cell-order icon-cell horizontal-divider sticky-col">

                    </div>

                    <div
                      className="cell-order shortcode-select horizontal-divider with-divider  sticky-col"
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <div className="icon-cell">
                        <Tooltip title={'Remove entry'}>
                          <RemoveCircleIcon
                            fontSize="small"
                            color="error"
                            style={{
                              color: 'red',
                              cursor: 'pointer',
                              marginTop: '16px',
                              marginLeft: '16px',
                            }}
                            onClick={() => this.removeRow(rowIndex)}
                          />
                        </Tooltip>
                      </div>

                      <Autocomplete
                        style={{ width: '260px', marginLeft: '-24px' }}
                        options={shortcodes.map((s) => s.shortcode)}
                        getOptionLabel={(option) => option}
                        value={row.shortcode}
                        onChange={(e, value) =>
                          this.handleShortcodeChange(rowIndex, value)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Shortcode"
                            variant="outlined"
                          />
                        )}
                      />

                      <IconButton
                        size="small"
                        style={{
                          marginLeft: '8px',
                          marginRight: '8px',
                          cursor: 'grab',
                        }}
                      >
                        <MenuIcon fontSize="small" />
                      </IconButton>
                    </div>

                    <div className="current-inventory-cell with-divider horizontal-divider">
                      <div
                        className="cell-unit"
                        style={{
                          visibility: this.state.showUnits
                            ? 'visible'
                            : 'hidden',
                          color: row.quantity < 0 ? 'red' : 'inherit',
                        }}
                      >
                        {row.quantity}
                      </div>

                      <div
                        className="with-divider"
                        style={{
                          visibility:
                            this.state.showUnits && this.state.showSkids
                              ? 'visible'
                              : 'hidden',
                        }}
                      />

                      <div
                        className="cell-unit"
                        style={{
                          visibility: this.state.showSkids
                            ? 'visible'
                            : 'hidden',
                          color: row.quantity < 0 ? 'red' : 'inherit',
                        }}
                      >
                        {row.skids}
                      </div>

                      <div className="with-divider" />

                      <div className="cell-unit">
                        {row?.daysOfCoverage || ''}
                      </div>
                    </div>

                    {dynamicColumns.map((col) => (
                      <div
                        key={col.id}
                        className="dynamic-cell with-divider horizontal-divider"
                      >
                        {(col.isProductRequirement ||
                          col.type === 'New Purchase Orders') &&
                        row.shortcode ? (
                          <>
                            <div
                              style={{
                                visibility: this.state.showUnits
                                  ? 'visible'
                                  : 'hidden',
                              }}
                            >
                              <TextField
                                inputProps={{
                                  style: { textAlign: 'center' },
                                  min: 0,
                                  inputMode: 'numeric',
                                  pattern: '[0-9]*',
                                }}
                                name="unit"
                                type="number"
                                variant="outlined"
                                size="small"
                                className="cell-editable-unit"
                                value={
                                  row.dynamic[col.id]?.unit &&
                                  parseFloat(row.dynamic[col.id]?.unit) !== 0
                                    ? row.dynamic[col.id]?.unit
                                    : ''
                                }
                                // value={row.dynamic[col.id]?.unit || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    this.updateDynamicValue(
                                      rowIndex,
                                      col.id,
                                      'unit',
                                      value
                                    );
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === '-' ||
                                    e.key === 'e' ||
                                    e.key === '+'
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onBlur={(e) =>
                                  this.handleDynamicValueBlur(
                                    rowIndex,
                                    col.id,
                                    'unit',
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            <div
                              className="with-divider"
                              style={{
                                visibility:
                                  this.state.showUnits && this.state.showSkids
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            />

                            <div
                              style={{
                                visibility: this.state.showSkids
                                  ? 'visible'
                                  : 'hidden',
                              }}
                            >
                              <TextField
                                inputProps={{
                                  style: { textAlign: 'center' },
                                  min: 0,
                                  step: '0.1',
                                  inputMode: 'decimal',
                                  pattern: '\\d*(\\.\\d*)?',
                                }}
                                type="number"
                                className="cell-editable-unit"
                                variant="outlined"
                                size="small"
                                name="skids"
                                value={
                                  row.dynamic[col.id]?.skids &&
                                  parseFloat(row.dynamic[col.id]?.skids) !== 0.0
                                    ? row.dynamic[col.id]?.skids
                                    : ''
                                }
                                // value={row.dynamic[col.id]?.skids || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*\.?\d*$/.test(value)) {
                                    this.updateDynamicValue(
                                      rowIndex,
                                      col.id,
                                      'skids',
                                      value
                                    );
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === '-' ||
                                    e.key === 'e' ||
                                    e.key === '+'
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onBlur={(e) => {
                                  let value = e.target.value;
                                  if (value && !isNaN(value)) {
                                    value = parseFloat(value).toFixed(2);
                                  }
                                  this.handleDynamicValueBlur(
                                    rowIndex,
                                    col.id,
                                    'skids',
                                    value
                                  );
                                }}
                              />
                            </div>

                            {col.type === 'Product Requirements' && (
                              <>
                                <div className="with-divider" />

                                <div className="cell-unit">
                                  {this.displayUnitAndCoverageAfterTransferToLocation(
                                    row.dynamic[col.id]?.unit,
                                    row.dynamic[col.id]?.skids,
                                    row.dynamic[col.id]?.daysOfCoverage
                                  )}
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <div
                              className="cell-unit"
                              style={{
                                visibility: this.state.showUnits
                                  ? 'visible'
                                  : 'hidden',
                              }}
                            >
                              {row.dynamic[col.id]?.unit || ''}
                            </div>
                            <div
                              className="with-divider"
                              style={{
                                visibility:
                                  this.state.showUnits && this.state.showSkids
                                    ? 'visible'
                                    : 'hidden',
                              }}
                            />
                            <div
                              className="cell-unit"
                              style={{
                                visibility: this.state.showSkids
                                  ? 'visible'
                                  : 'hidden',
                              }}
                            >
                              {row.dynamic[col.id]?.skids || ''}
                            </div>
                            {col.type === 'Product Requirements' && (
                              <div className="cell-unit">
                                {this.displayUnitAndCoverageAfterTransferToLocation(
                                  row.dynamic[col.id]?.unit,
                                  row.dynamic[col.id]?.skids,
                                  row.dynamic[col.id]?.daysOfCoverage
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>

            {this.state.rows.length > 0 && (
              <div
                className="table-row"
                style={{
                  gridTemplateColumns,
                  fontWeight: 'bold',
                  marginTop: '-16px',
                }}
              >
                <div className="cell-order icon-cell horizontal-divider sticky-col" />
                <div className="cell-order shortcode-select with-divider horizontal-divider sticky-col"></div>

                {/* Quantity + Skids under Current Inventory */}
                <div className="current-inventory-cell with-divider horizontal-divider">
                  <div
                    className="cell-unit"
                    style={{
                      visibility: this.state.showUnits ? 'visible' : 'hidden',
                    }}
                  >
                    {parseFloat(totalRow.quantity) ? totalRow.quantity : ''}
                  </div>
                  <div
                    className="with-divider"
                    style={{
                      visibility:
                        this.state.showUnits && this.state.showSkids
                          ? 'visible'
                          : 'hidden',
                    }}
                  />
                  <div
                    className="cell-unit"
                    style={{
                      visibility: this.state.showSkids ? 'visible' : 'hidden',
                    }}
                  >
                    {parseFloat(totalRow.skids) ? totalRow.skids : ''}
                  </div>
                  <div className="with-divider" />

                  <div className="cell-unit">{''}</div>
                </div>

                {/* Loop through dynamic columns */}
                {this.state.dynamicColumns.map((col) => (
                  <div
                    key={col.id}
                    className="dynamic-cell with-divider horizontal-divider"
                  >
                    <div
                      className="cell-unit"
                      style={{
                        visibility: this.state.showUnits ? 'visible' : 'hidden',
                      }}
                    >
                      {parseFloat(totalRow.dynamic[col.id].unit)
                        ? totalRow.dynamic[col.id].unit
                        : ''}
                    </div>

                    <div
                      className="with-divider"
                      style={{
                        visibility:
                          this.state.showUnits && this.state.showSkids
                            ? 'visible'
                            : 'hidden',
                      }}
                    />

                    <div
                      className="cell-unit"
                      style={{
                        visibility: this.state.showSkids ? 'visible' : 'hidden',
                      }}
                    >
                      {parseFloat(totalRow.dynamic[col.id].skids)
                        ? totalRow.dynamic[col.id].skids
                        : ''}
                    </div>

                    {col.type === 'Product Requirements' && (
                      <>
                        <div className="with-divider" />

                        <div className="cell-unit">{''}</div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}

            <div className="add-icon sticky-col">
              <Tooltip title={'Add entry'} style={{ float: 'right' }}>
                <AddCircleIcon
                  fontSize="small"
                  color="secondary"
                  onClick={this.addRow}
                  style={{
                    color: '#b0d48c',
                    cursor: 'pointer',
                    marginLeft: '16px',
                    marginTop: '16px',
                    marginBottom: '24px',
                  }}
                />
              </Tooltip>
            </div>
          </div>

          <Popover
            open={Boolean(this.state.productRequirementPopover.anchorEl)}
            anchorEl={this.state.productRequirementPopover.anchorEl}
            onClose={this.closeProductRequirementPopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <div style={{ padding: 20, width: 300 }}>
              <Autocomplete
                style={{ marginBottom: 16 }}
                options={this.props.availableLocations.map((loc) => loc.name)}
                value={this.state.productRequirementPopover.location}
                getOptionLabel={(option) => option}
                onChange={(e, value) => {
                  this.setState((prev) => ({
                    productRequirementPopover: {
                      ...prev.productRequirementPopover,
                      location: value || '',
                    },
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{ shrink: true }}
                    label="Location"
                    required
                    variant="outlined"
                  />
                )}
              />

              <TextField
                label="Required days of coverage"
                variant="outlined"
                required
                fullWidth
                style={{ marginBottom: 16 }}
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                InputLabelProps={{ shrink: true }}
                value={this.state.productRequirementPopover.daysToCover}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*$/.test(val)) {
                    this.setState((prev) => ({
                      productRequirementPopover: {
                        ...prev.productRequirementPopover,
                        daysToCover: val,
                      },
                    }));
                  }
                }}
              />

              <Autocomplete
                style={{ marginBottom: 16 }}
                options={[7, 14, 21, 28]}
                getOptionLabel={(option) => option.toString()}
                isOptionEqualToValue={(option, value) => option === value}
                value={
                  this.state.productRequirementPopover.daysOfCoverateBaseOn
                }
                onChange={(e, value) => {
                  this.setState((prev) => ({
                    productRequirementPopover: {
                      ...prev.productRequirementPopover,
                      daysOfCoverateBaseOn: value || '',
                    },
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Average days of coverage"
                    variant="outlined"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />

              <Autocomplete
                multiple
                disableCloseOnSelect
                options={
                  this.props.allShippedFTL?.filter(
                    (ftl) =>
                      ftl.toAddress?.selectedLocation ===
                      this.state.productRequirementPopover?.location
                  ) || []
                }
                value={
                  this.props.allShippedFTL?.filter((ftl) =>
                    this.state.productRequirementPopover?.selectedTransitShipment?.some(
                      (s) => s.shipmentNumber === ftl.shipmentNumber
                    )
                  ) || []
                }
                onChange={(_, value) =>
                  this.setState((prev) => ({
                    productRequirementPopover: {
                      ...prev.productRequirementPopover,
                      selectedTransitShipment: value.map((ftl) => ({
                        shipmentNumber: ftl.shipmentNumber,
                        location: ftl.toAddress?.selectedLocation || '',
                        fullTruckloadId: ftl?.fullTruckloadId || '',
                      })),
                    },
                  }))
                }
                getOptionLabel={(option) =>
                  `${option.shipmentNumber} - ${
                    option.toAddress?.selectedLocation || ''
                  }`
                }
                isOptionEqualToValue={(option, value) =>
                  option.shipmentNumber === value.shipmentNumber
                }
                renderTags={(value) =>
                  value.map((option) => (
                    <Chip
                      key={option.shipmentNumber}
                      variant="outlined"
                      size="small"
                      label={`${option.shipmentNumber} - ${
                        option.toAddress?.selectedLocation || ''
                      }`}
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                    />
                  ))
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.shipmentNumber} -{' '}
                    {option.toAddress?.selectedLocation}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select FTL In Transit(s)"
                    variant="outlined"
                  />
                )}
              />

              <button
                onClick={this.handleProductRequirementSubmit}
                disabled={
                  !this.state.productRequirementPopover.location ||
                  !this.state.productRequirementPopover.daysToCover ||
                  !this.state.productRequirementPopover.daysOfCoverateBaseOn
                }
                style={{
                  marginTop: 16,
                  backgroundColor:
                    !this.state.productRequirementPopover.location ||
                    !this.state.productRequirementPopover.daysToCover ||
                    !this.state.productRequirementPopover.daysOfCoverateBaseOn
                      ? '#ccc'
                      : '#005E73',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 4,
                  padding: '8px 16px',
                  cursor:
                    !this.state.productRequirementPopover.location ||
                    !this.state.productRequirementPopover.daysToCover ||
                    !this.state.productRequirementPopover.daysOfCoverateBaseOn
                      ? 'not-allowed'
                      : 'pointer',
                  width: '100%',
                  opacity:
                    !this.state.productRequirementPopover.location ||
                    !this.state.productRequirementPopover.daysToCover ||
                    !this.state.productRequirementPopover.daysOfCoverateBaseOn
                      ? 0.6
                      : 1,
                }}
              >
                OK
              </button>
            </div>
          </Popover>

          <Popover
            open={Boolean(this.state.selectedBrandsPopover.anchorEl)}
            anchorEl={this.state.selectedBrandsPopover.anchorEl}
            onClose={() =>
              this.setState({
                selectedBrandsPopover: {
                  anchorEl: null,
                  stage: 'menu',
                  selected: [],
                },
              })
            }
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            {(() => {
              const { stage } = this.state.selectedBrandsPopover;
              const hasBrands = this.state.savedSelectedBrands.length > 0;

              if (stage === 'menu')
                return (
                  <div style={{ padding: 16, width: 200 }}>
                    <button
                      style={{
                        marginTop: 16,
                        backgroundColor: '#005E73',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        padding: '8px 16px',
                        cursor: 'pointer',
                        width: '100%',
                      }}
                      onClick={() =>
                        this.setState((prev) => ({
                          selectedBrandsPopover: {
                            ...prev.selectedBrandsPopover,
                            stage: 'add',
                            selected: prev.savedSelectedBrands,
                          },
                        }))
                      }
                    >
                      Add/Remove Brand
                    </button>
                  </div>
                );

              const isAdding = stage === 'add';

              return (
                <div style={{ padding: 16, width: 250 }}>
                  <Autocomplete
                    multiple
                    options={
                      this.props.manufacturers?.sort((a, b) => {
                        return a.toLowerCase().localeCompare(b.toLowerCase());
                      }) ?? []
                    }
                    value={this.state.selectedBrandsPopover.selected ?? []}
                    onChange={(_, value) =>
                      this.setState((prev) => ({
                        selectedBrandsPopover: {
                          ...prev.selectedBrandsPopover,
                          selected: value,
                        },
                      }))
                    }
                    getOptionLabel={(option) => option}
                    isOptionEqualToValue={(option, value) => option === value}
                    renderTags={(value) =>
                      value.map((option) => (
                        <Chip
                          key={option}
                          variant="outlined"
                          size="small"
                          label={option}
                          style={{
                            borderColor: '#acd685',
                            margin: '1px 6px 1px 0',
                            fontSize: '12px',
                          }}
                        />
                      ))
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select brand(s)"
                        variant="outlined"
                      />
                    )}
                  />

                  <button
                    onClick={
                      isAdding
                        ? this.handleAddBrandConfirm
                        : this.handleRemoveBrandConfirm
                    }
                    style={{
                      marginTop: 10,
                      width: '100%',
                      padding: '8px 12px',
                      backgroundColor: '#005E73',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 4,
                      cursor: 'pointer',
                    }}
                  >
                    OK
                  </button>
                </div>
              );
            })()}
          </Popover>

          <Popover
            style={{ marginTop: '-40px', marginLeft: '24px' }}
            open={Boolean(columnTypeAnchorEl)}
            anchorEl={columnTypeAnchorEl}
            onClose={this.closeColumnTypePopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <div style={{ padding: 10 }}>
              {dynamicColumnTypes.map((type, idx) => (
                <div
                  className="column-buttons"
                  key={idx}
                  onClick={() => {
                    this.addDynamicColumn(type);
                    this.closeColumnTypePopover();
                  }}
                >
                  {type}
                </div>
              ))}
            </div>
          </Popover>

          <Popover
            open={Boolean(this.state.openPOPopover.anchorEl)}
            anchorEl={this.state.openPOPopover.anchorEl}
            onClose={() =>
              this.setState({
                openPOPopover: {
                  anchorEl: null,
                  columnId: null,
                  selectedPO: [],
                },
                showPOSelector: false,
              })
            }
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <div style={{ padding: 20, width: 300 }}>
              {!this.state.showPOSelector && (
                <>
                  <button
                    style={btnStyle}
                    onClick={() => this.setState({ showPOSelector: true })}
                  >
                    Add/Remove Purchase Order
                  </button>
                </>
              )}

              {this.state.showPOSelector && (
                <>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={this.props.openAndPartialPurchaseOrders}
                    value={this.props.openAndPartialPurchaseOrders.filter(
                      (po) =>
                        this.state.openPOPopover.selectedPO.includes(
                          po.poNumber
                        )
                    )}
                    onChange={(_, value) =>
                      this.setState((prev) => ({
                        openPOPopover: {
                          ...prev.openPOPopover,
                          selectedPO: value.map((po) => po.poNumber),
                        },
                      }))
                    }
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) =>
                      option.poNumber === value.poNumber
                    }
                    renderTags={(value) =>
                      value.map((option) => (
                        <Chip
                          key={option.poNumber}
                          variant="outlined"
                          size="small"
                          label={option.name}
                          style={{
                            borderColor: '#acd685',
                            margin: '1px 6px 1px 0',
                            fontSize: '12px',
                          }}
                        />
                      ))
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select PO(s)"
                        variant="outlined"
                      />
                    )}
                  />

                  <button
                    disabled={!this.state.openPOPopover.selectedPO}
                    style={{
                      marginTop: 16,
                      backgroundColor: !this.state.openPOPopover.selectedPO
                        ? '#ccc'
                        : '#005E73',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 4,
                      padding: '8px 16px',
                      cursor: !this.state.openPOPopover.selectedPO
                        ? 'not-allowed'
                        : 'pointer',
                      width: '100%',
                      opacity: !this.state.openPOPopover.selectedPO ? 0.6 : 1,
                    }}
                    onClick={() =>
                      this.setState({
                        showAppendPromptPO: true,
                        onPOAppendConfirm: (shouldAppendNewRows) =>
                          this.handleOpenPOSubmit(shouldAppendNewRows),
                      })
                    }
                  >
                    OK
                  </button>
                </>
              )}
            </div>
          </Popover>

          {/*ftl in transit popover*/}
          <Popover
            open={Boolean(this.state.ftlInTransitPopover.anchorEl)}
            anchorEl={this.state.ftlInTransitPopover.anchorEl}
            onClose={() =>
              this.setState({
                ftlInTransitPopover: {
                  anchorEl: null,
                  columnId: null,
                  selectedTransitShipment: [],
                },
                showFTLInTransitSelector: false,
              })
            }
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <div style={{ padding: 20, width: 300 }}>
              {!this.state.showFTLInTransitSelector && (
                <>
                  <button
                    style={btnStyle}
                    onClick={() =>
                      this.setState({ showFTLInTransitSelector: true })
                    }
                  >
                    Add/Remove Shipment Number
                  </button>
                </>
              )}

              {this.state.showFTLInTransitSelector && (
                <>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={this.props.allShippedFTL}
                    value={this.props.allShippedFTL?.filter((ftl) =>
                      this.state.ftlInTransitPopover.selectedTransitShipment.some(
                        (s) => s.shipmentNumber === ftl.shipmentNumber
                      )
                    )}
                    onChange={(_, value) =>
                      this.setState((prev) => ({
                        ftlInTransitPopover: {
                          ...prev.ftlInTransitPopover,
                          selectedTransitShipment: value.map((ftl) => ({
                            shipmentNumber: ftl.shipmentNumber,
                            location: ftl.toAddress?.selectedLocation || '',
                          })),
                        },
                      }))
                    }
                    getOptionLabel={(option) =>
                      `${option.shipmentNumber} - ${
                        option.toAddress?.selectedLocation || ''
                      }`
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.shipmentNumber === value.shipmentNumber
                    }
                    renderTags={(value) =>
                      value.map((option) => (
                        <Chip
                          key={option.shipmentNumber}
                          variant="outlined"
                          size="small"
                          label={`${option.shipmentNumber} - ${
                            option.toAddress?.selectedLocation || ''
                          }`}
                          style={{
                            borderColor: '#acd685',
                            margin: '1px 6px 1px 0',
                            fontSize: '12px',
                          }}
                        />
                      ))
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.shipmentNumber} -{' '}
                        {option.toAddress?.selectedLocation}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Shipment Number(s)"
                        variant="outlined"
                      />
                    )}
                  />

                  <button
                    disabled={
                      !this.state.ftlInTransitPopover.selectedTransitShipment
                    }
                    style={{
                      marginTop: 16,
                      backgroundColor: !this.state.ftlInTransitPopover
                        .selectedTransitShipment
                        ? '#ccc'
                        : '#005E73',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 4,
                      padding: '8px 16px',
                      cursor: !this.state.ftlInTransitPopover
                        .selectedTransitShipment
                        ? 'not-allowed'
                        : 'pointer',
                      width: '100%',
                      opacity: !this.state.ftlInTransitPopover
                        .selectedTransitShipment
                        ? 0.6
                        : 1,
                    }}
                    onClick={() => {
                      this.setState({
                        showAppendPromptFTL: true,
                        ftlAppendConfirm: (shouldAppendNewRows) =>
                          this.handleOpenFTLTransitSubmit(shouldAppendNewRows),
                      });
                    }}
                  >
                    OK
                  </button>
                </>
              )}
            </div>
          </Popover>

          <Popover
            open={Boolean(this.state.newPOPopover.anchorEl)}
            anchorEl={this.state.newPOPopover.anchorEl}
            onClose={this.resetNewPOPopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <div style={{ padding: 20, width: 250 }}>
              {/* LOCATION */}
              <Autocomplete
                style={{ marginBottom: 16 }}
                options={this.props.availableLocations.map((l) => l.name)}
                value={this.state.newPOPopover.selectedLocation}
                onChange={(e, val) =>
                  this.setState((prev) => ({
                    newPOPopover: {
                      ...prev.newPOPopover,
                      selectedLocation: val || '',
                    },
                  }))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Location"
                    variant="outlined"
                    required
                  />
                )}
              />

              {/* SUPPLIER */}
              <Autocomplete
                options={this.props.suppliers}
                disableClearable
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option?.name || ''
                }
                value={this.state.newPOPopover.selectedSupplier || null}
                onChange={(e, val) =>
                  this.setState((prev) => ({
                    newPOPopover: {
                      ...prev.newPOPopover,
                      selectedSupplier: val.name,
                    },
                  }))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Supplier"
                    variant="outlined"
                    required
                  />
                )}
              />

              <button
                style={{
                  marginTop: 16,
                  backgroundColor:
                    !this.state.newPOPopover.selectedSupplier ||
                    !this.state.newPOPopover.selectedLocation
                      ? '#ccc'
                      : '#005E73',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 4,
                  padding: '8px 16px',
                  cursor:
                    !this.state.newPOPopover.selectedSupplier ||
                    !this.state.newPOPopover.selectedLocation
                      ? 'not-allowed'
                      : 'pointer',
                  width: '100%',
                  opacity:
                    !this.state.newPOPopover.selectedSupplier ||
                    !this.state.newPOPopover.selectedLocation
                      ? 0.6
                      : 1,
                }}
                disabled={
                  !this.state.newPOPopover.selectedSupplier ||
                  !this.state.newPOPopover.selectedLocation
                }
                onClick={this.handleNewPOSubmit}
              >
                OK
              </button>
            </div>
          </Popover>
        </div>
      </React.Fragment>
    );
  }
}


export default OrderPlanningForm;